import { Component, inject, PLATFORM_ID, Inject, OnInit } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LANGS } from '../../constants/lang.constants';
import { MatButton } from '@angular/material/button';
import { DevService } from '../../services/dev.service';
import { AuthService } from '../../services/auth.service';
import {
  MatButtonToggle,
  MatButtonToggleChange,
  MatButtonToggleGroup,
} from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink,NavigationStart } from '@angular/router';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ToastrService } from 'ngx-toastr';
import { SharedStorageService } from '../../services/shared-storage.service';
import { ChatbotComponent } from '../../../pages/chatbot/chatbot.component';
import { DuoActionDialogComponent } from '../dialogs/duo-action-dialog/duo-action-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MemberInfoResponse, ModifyInfoService } from '../../services/modify-info.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatButton,
    TranslatePipe,
    MatButtonToggleGroup,
    MatButtonToggle,
    FormsModule,
    RouterLink,
    NgOptimizedImage,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  protected readonly LANGS = LANGS;
  translateService: TranslateService = inject(TranslateService);
  devService: DevService = inject(DevService);
  authService: AuthService = inject(AuthService);
  toastr: ToastrService = inject(ToastrService);
  router: Router = inject(Router);
  dialog: MatDialog = inject(MatDialog);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  modifyInfoService: ModifyInfoService = inject(ModifyInfoService);

  isMenuOpened: boolean = false;
  routerSub: any;

  env: any = (window as any)?.env;

  ngOnInit(): void {
    // 如果已經有登入狀態，就不要覆蓋（避免髒資料被覆蓋）
    const existingLoginStatus = this.sharedStorageService.get('loginStatus');
    
    if (!existingLoginStatus) {
      // 檢查是否登入
      if (this.authService.isLogin() && this.sharedStorageService.get('createMemberRequest')?.idNo) {
        this.sharedStorageService.set('loginStatus', 'memberLogin');
      } else {
        this.sharedStorageService.set('loginStatus', 'newFriend');
      }
    }
    
    console.log(this.sharedStorageService.get('loginStatus'));

    //偵測瀏覽器返回
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // 只偵測瀏覽器歷史導航（返回或前進）
        if (event.navigationTrigger === 'popstate') {

          const reserveType =this.sharedStorageService.get('reserveType');
          if(reserveType){
            // 如果是預約流程才會跳彈窗
            // 立即導航回當前 URL，取消 popstate 導航（替換歷史記錄，避免頁面切換）
          const currentUrl = this.router.url;  // 取得當前 URL
          this.router.navigate([currentUrl], { replaceUrl: true });  // 強制留在當前頁，替換歷史 entry
          // 偵測到返回
          console.log("偵測到返回");
          
          const resetConfirmDialog = this.dialog.open(DuoActionDialogComponent, {
          data: {
            title: this.translateService.instant('header.browser-back-dialog.title'),
            message: this.translateService.instant('header.browser-back-dialog.message'),
            leftButtonText: this.translateService.instant('common.button.cancel'),//取消
            rightButtonText: this.translateService.instant(
              'common.button.confirm'//確認
            ),
            leftButtonAction: () => resetConfirmDialog.close(),
            rightButtonAction: () => {
              resetConfirmDialog.close();
              console.log('增加確認後邏輯')
              // 回到首頁 
              this.navigateToHome();
            },
            showCloseButton: false,
          },
        });
          }
          
        }
      }
    });
  }

  // 導到會員中心
  goToMemberCenter() {
    // 解決髒資料問題，若是已登入狀態
    if (this.sharedStorageService.get('loginStatus') === 'memberLogin') {
    this.modifyInfoService.getMemberInfo().subscribe({
        next: (res: MemberInfoResponse) => {

            // 髒資料由 interceptor 處理
            if (res.statusCode === 'S0000') {
                console.log('token有效，資料保留');
                this.router.navigate(['/healthcheck/member/mybooking']).then();
            }
        }
        });
    }
  }

  // 切換語言
  switchLanguage(lang: string): void {
    this.translateService.use(lang);
  }

  logOut() {
    // 檢查是否在健調表頁面
    if (this.router.url.includes('/healthcheck/member/form')) {
      // 在健調表頁面時，先導航離開（會觸發 CanDeactivateGuard）
      // 如果用戶確認離開，再執行登出
      this.navigateAwayAndLogout();
    } else {
      // 不在健調表頁面，直接登出
      this.performLogout();
    }
  }

  /**
   * 導航離開健調表頁面並登出
   */
  private navigateAwayAndLogout(): void {
    // 設置一個標記，表示想要登出
    sessionStorage.setItem('pendingLogout', 'true');

    // 嘗試導航到會員中心（會觸發 CanDeactivateGuard）
    this.router.navigate(['/healthcheck/member']).then((navigationSuccessful) => {
      // 檢查是否成功導航（選擇了離開）
      if (navigationSuccessful) {
        // 檢查是否有待處理的登出
        const pendingLogout = sessionStorage.getItem('pendingLogout');
        if (pendingLogout === 'true') {
          sessionStorage.removeItem('pendingLogout');
          // 延遲一下再執行登出，確保導航完成
          setTimeout(() => {
            this.performLogout();
          }, 100);
        }
      } else {
        // 導航失敗（選擇繼續編輯），清除登出標記
        sessionStorage.removeItem('pendingLogout');
      }
    });
  }

  /**
   * 執行實際的登出操作
   */
  private performLogout(): void {
    this.authService.performLogout().subscribe({
      next: (res) => {
        console.log('登出 API 成功:', res);
        this.toastr.success(
          this.translateService.instant('login-register.logout-success')
        );
        this.authService.clearToken();
        this.sharedStorageService.remove('myReservation');
        this.sharedStorageService.remove('savedQuestionnaireData');
        this.router.navigate(['/healthcheck']).then(() => {
          window.location.reload();
        });
      },
      error: (error) => {
        console.error('登出 API 失敗:', error);
        // 即使 API 失敗也要執行本地清理和導航
        this.toastr.success(
          this.translateService.instant('login-register.logout-success')
        );
        this.authService.clearToken();
        this.sharedStorageService.remove('myReservation');
        this.sharedStorageService.remove('savedQuestionnaireData');
        this.router.navigate(['/healthcheck']).then(() => {
          window.location.reload();
        });
      }
    });
  }

  // 回到首頁
  navigateToHome(): void {
    this.sharedStorageService.clear();
    this.router.navigate(['/healthcheck']).then();
  }

  toggleLoginStatus(event: MatButtonToggleChange) {
    this.sharedStorageService.set(
      'loginStatus',
      event.value ? 'memberLogin' : 'newFriend'
    );
    console.log(this.sharedStorageService.get('loginStatus'));
  }
  
  ngOnDestroy(): void {
    // 取消訂閱返回的偵測以避免記憶體洩漏
    if (this.routerSub) {
      this.routerSub.unsubscribe();
      console.log("取消訂閱返回");
    }
  }

  // 注入髒資料(測試用)
  injectDirtyData() {

    const reserveType = this.sharedStorageService.get('reserveType');
    let dirtyData = {};

    // 個人
    if (reserveType === '1') {
      dirtyData = {
      "homeShowAnimation": false,
      "createMemberRequest": {
          "gender": "M",
          "birthday": "19770707",
          "name": "測試",
          "idNo": "A123456789",
          "cell": "0939696767",
          "email": "uuu@uu44.com",
          "password": "",
          "confirmPassword": "",
          "chartNo": "8002109631"
      },
      "loginStatus": "memberLogin",
      "myReservation": {
          "flowCode": "0",
          "bookStatus": "",
          "diffDates": 0,
          "bookDate": "",
          "caseNo": "",
          "companyNo": "",
          "familyFlag": ""
      },
      "reserveType": "1",
      "userPlanRequest": {
          "orgNo": "02",
          "gender": "M",
          "birthday": "19770707",
          "age": "48",
          "idNo": "A123456789",
          "uuid": "",
          "name": "測試",
          "cell": "0939696767",
          "email": "uuu@uu44.com",
          "telH": "",
          "telO": "",
          "zipCode": "",
          "history": [
              "既往病史_以下皆無"
          ],
          "family": [
              "家族病史_以下皆無"
          ],
          "subjectiveSymptoms": [
              "自覺症狀_以下皆無"
          ],
          "femaleStatus": false,
          "femaleMenopausal": false,
          "funcType": "0",
          "identityType": "0"
      },
      "reserveStep": 5,
      "hasFilledReserveInfo": true,
      "tempPersonalDiseaseDetails": {},
      "tempPersonalDiseaseCheck": {
          "questionId": "474",
          "questionAnswers": [
              {
                  "choiceId": "1540",
                  "answer": "1"
              }
          ]
      },
      "tempPersonalNoneOfFollowing": true,
      "tempFamilyDiseaseCheck": {
          "questionId": "483",
          "questionAnswers": [
              {
                  "choiceId": "1592",
                  "answer": "1"
              }
          ]
      },
      "tempFamilyNoneOfFollowing": true,
      "tempSubjectiveSymptomDiseaseCheck": {
          "questionId": "472",
          "questionAnswers": [
              {
                  "choiceId": "1510",
                  "answer": "1"
              }
          ]
      },
      "tempSubjectiveSymptomNoneOfFollowing": true,
      "currentHealthStep": 3,
      "questionnaireChecks": [
          {
              "questionId": "474",
              "questionAnswers": [
                  {
                      "choiceId": "1540",
                      "answer": "1"
                  }
              ]
          },
          {
              "questionId": "483",
              "questionAnswers": [
                  {
                      "choiceId": "1592",
                      "answer": "1"
                  }
              ]
          },
          {
              "questionId": "472",
              "questionAnswers": [
                  {
                      "choiceId": "1510",
                      "answer": "1"
                  }
              ]
          }
      ],
      "userPlanResponse": {
          "riskItems": [
              "消化系統",
              "心血管及代謝系統",
              "營養素與礦物質"
          ],
          "allCheckup": {
              "discountRate": "0.73748",
              "packageList": [
                  {
                      "deptName": "一般檢查",
                      "deptEName": "General Examination",
                      "examItemList": [
                          {
                              "examName": "體脂肪率",
                              "examItem": "PE00010019",
                              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6588167,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體質量指數",
                              "examItem": "PE00010006",
                              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6336039,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "腰圍",
                              "examItem": "PE00010017",
                              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.4081422,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "血壓",
                              "examItem": "PE00010009A",
                              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.36203143,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "脈搏",
                              "examItem": "PE00010007A",
                              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.02100955,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "上下肢肌力檢測",
                              "examItem": "MMS001A",
                              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.016194332,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身高",
                              "examItem": "PE00010001",
                              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "200",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "體重",
                              "examItem": "PE00010002",
                              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "理想體重",
                              "examItem": "PE00010003",
                              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體組成分析",
                              "examItem": "PE00010040",
                              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "心血管及代謝系統",
                      "deptEName": "Cardiovascular and Metabolic System",
                      "examItemList": [
                          {
                              "examName": "低密度脂蛋白-膽固醇",
                              "examItem": "L3005200",
                              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "375",
                              "rateStatus": true,
                              "abnormalRatio": 0.6037854,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總膽固醇",
                              "examItem": "L3001900",
                              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.5826974,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高敏感性C反應蛋白",
                              "examItem": "L3018400",
                              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.4319874,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "低/高密度脂蛋白比值",
                              "examItem": "L300350002",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.3974091,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前血糖",
                              "examItem": "L3000800",
                              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.38921002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "靜式心電圖",
                              "examItem": "L1001100A",
                              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "350",
                              "rateStatus": true,
                              "abnormalRatio": 0.3740002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "糖化血色素",
                              "examItem": "L3000700",
                              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.32150638,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "三酸甘油脂",
                              "examItem": "L3002000",
                              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "180",
                              "rateStatus": true,
                              "abnormalRatio": 0.31154653,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總/高密度膽固醇比",
                              "examItem": "L300350001",
                              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.27469006,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高密度脂蛋白-膽固醇",
                              "examItem": "L3003500",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.18991618,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "同半胱胺酸",
                              "examItem": "L3018300",
                              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.15489566,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "脫氫表雄酮硫酸鹽",
                              "examItem": "LI005300",
                              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.0952381,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前胰島素(含阻抗)",
                              "examItem": "LI001700A",
                              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.08467293,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "甲狀腺刺激素",
                              "examItem": "LI000400",
                              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.034355164,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "游離甲狀腺素",
                              "examItem": "LI003400",
                              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.028777989,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "十年心血管疾病風險評估",
                              "examItem": "R401470005",
                              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "全身體脂肪分析",
                              "examItem": "R1140700A",
                              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1200",
                              "rateStatus": true,
                              "abnormalRatio": 0.95320195,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "心臟超音波",
                              "examItem": "R4011700A",
                              "examMemo": "心臟超音波能無痛檢查心臟結構與功能，評估心臟疾病風險、瓣膜狀況及血流，幫助早期發現問題。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "3500",
                              "rateStatus": true,
                              "abnormalRatio": 0.7822513,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "24小時連續性心電圖監測檢查",
                              "examItem": "L1001500A",
                              "examMemo": "24小時連續性心電圖監測心臟連續性活動，評估心律不整或心臟疾病風險。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "4200",
                              "rateStatus": true,
                              "abnormalRatio": 0.7186441,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "甲狀腺超音波",
                              "examItem": "R2026000A",
                              "examMemo": "透過影像檢查甲狀腺的大小、形狀以及是否有結節或其他異常變化。常搭配血液檢驗（如TSH、T3、T4）一同評估甲狀腺健康狀況。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.71466434,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "頸動脈超音波",
                              "examItem": "R4014700A",
                              "examMemo": "頸動脈超音波檢查可以評估頸部血管的狀況，發現動脈硬化或斑塊，幫助預防中風及心血管疾病的風險。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "2000",
                              "rateStatus": true,
                              "abnormalRatio": 0.63145137,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "緻密低密度脂蛋白-超壞膽固醇",
                              "examItem": "L3005400",
                              "examMemo": "緻密低密度脂蛋白膽固醇（sdLD）被稱為超壞膽固醇，與心血管疾病風險高度相關，檢查sdLD可及早發現動脈硬化潛在風險，促進心臟健康管理。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.58426964,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "周邊動脈硬化評估",
                              "examItem": "R4014710A",
                              "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1200",
                              "rateStatus": true,
                              "abnormalRatio": 0.3724259,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "肌酸磷酸激脢",
                              "examItem": "L3000600",
                              "examMemo": "與肌肉細胞相關，數值上升常見於劇烈運動或肌肉受損情況。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "280",
                              "rateStatus": true,
                              "abnormalRatio": 0.25373134,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "脂蛋白(a)",
                              "examItem": "FM000021",
                              "examMemo": "脂蛋白(a)結構類似LDL（壞膽固醇），過高會顯著增加心肌梗塞、中風、血管狹窄的風險",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.17082012,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "運動心電圖",
                              "examItem": "L1001200A",
                              "examMemo": "運動心電圖檢查可評估心臟在運動狀態下血壓與心電圖的變化，評估心臟是否有缺氧、心絞痛或心律不整的情形。檢查過程中，會讓在跑步機上逐漸增加運動強度，並定期測量心跳、血壓及心電圖。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "2000",
                              "rateStatus": true,
                              "abnormalRatio": 0.113300495,
                              "deptName": "心血管及代謝系統"
                          }
                      ]
                  },
                  {
                      "deptName": "男性醫學",
                      "deptEName": "Male medicine",
                      "examItemList": [
                          {
                              "examName": "睪固酮",
                              "examItem": "LI001400",
                              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.08185654,
                              "deptName": "男性醫學"
                          }
                      ]
                  },
                  {
                      "deptName": "腫瘤標記",
                      "deptEName": "Tumor Biomarker",
                      "examItemList": [
                          {
                              "examName": "CYFRA 21-1腫瘤標記",
                              "examItem": "LI006300",
                              "examMemo": "CYFRA 21-1是肺部腫瘤參考指標，可作為肺癌追蹤監測與輔助診斷",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1000",
                              "rateStatus": true,
                              "abnormalRatio": 0.2621951,
                              "deptName": "腫瘤標記"
                          },
                          {
                              "examName": "游離前列腺特異抗原",
                              "examItem": "LI006900",
                              "examMemo": "游離前列腺特異抗原（FreePSA）是前列腺健康的參考指標，特別是前列腺癌，提升及早診斷和治療的機會。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.24683367,
                              "deptName": "腫瘤標記"
                          },
                          {
                              "examName": "腫瘤組織多胜脢抗原",
                              "examItem": "LI005600",
                              "examMemo": "腫瘤組織多胜脢抗原（TPA）是上皮細胞腫瘤的標記。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1000",
                              "rateStatus": true,
                              "abnormalRatio": 0.19399539,
                              "deptName": "腫瘤標記"
                          },
                          {
                              "examName": "EB病毒抗體IgA",
                              "examItem": "L2004200A",
                              "examMemo": "EB病毒抗體IgA檢查評估是否感染EB病毒，常用於鼻咽癌高風險族群的初步篩檢",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.17175888,
                              "deptName": "腫瘤標記"
                          }
                      ]
                  },
                  {
                      "deptName": "肺部檢查",
                      "deptEName": "Lung Examination",
                      "examItemList": [
                          {
                              "examName": "胸部X光（正面及左側面）",
                              "examItem": "R132001DA",
                              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "720",
                              "rateStatus": true,
                              "abnormalRatio": 0.33959147,
                              "deptName": "肺部檢查"
                          },
                          {
                              "examName": "肺功能檢查",
                              "examItem": "L1001400A",
                              "examMemo": "肺功能檢查評估肺部的呼吸能力，幫助診斷慢性阻塞性肺病等疾病，及早發現問題可改善呼吸健康。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "350",
                              "rateStatus": true,
                              "abnormalRatio": 0.24436091,
                              "deptName": "肺部檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "風濕免疫系統",
                      "deptEName": "Rheumatology and Immunology",
                      "examItemList": [
                          {
                              "examName": "全免疫球蛋白E定量",
                              "examItem": "L2001300",
                              "examMemo": "全免疫球蛋白E（IgE）定量可評估過敏反應及免疫系統狀況，IgE高可能有過敏、氣喘。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.31327432,
                              "deptName": "風濕免疫系統"
                          },
                          {
                              "examName": "抗核抗體",
                              "examItem": "L2003100",
                              "examMemo": "抗核抗體（ANA）是一種自體免疫標記，檢查可協助診斷紅斑性狼瘡及其他自體免疫疾病，陽性結果需要進一步評估。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.12101911,
                              "deptName": "風濕免疫系統"
                          }
                      ]
                  },
                  {
                      "deptName": "耳鼻喉科檢查",
                      "deptEName": "ENT Examination",
                      "examItemList": [
                          {
                              "examName": "密閉式純音聽力檢查",
                              "examItem": "T700110051A",
                              "examMemo": "密閉式純音聽力檢查可評估個人聽力狀況，幫助識別聽力損傷。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.3457249,
                              "deptName": "耳鼻喉科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "營養素與礦物質",
                      "deptEName": "Nutrient & Mineral",
                      "examItemList": [
                          {
                              "examName": "維他命 D",
                              "examItem": "VIT0002",
                              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.88415545,
                              "deptName": "營養素與礦物質"
                          },
                          {
                              "examName": "維他命 B12",
                              "examItem": "VIT0005",
                              "examMemo": "維他命B12檢查能評估血液中B12濃度，低可能導致貧血、神經問題及認知障礙，早期發現有助於預防這些健康問題。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.26461643,
                              "deptName": "營養素與礦物質"
                          },
                          {
                              "examName": "葉酸",
                              "examItem": "VIT0006",
                              "examMemo": "葉酸是合成DNA和紅血球的重要營養素，缺乏可能導致貧血和神經管缺陷。檢查葉酸有助於評估營養狀態及孕婦胎兒健康。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.17286652,
                              "deptName": "營養素與礦物質"
                          }
                      ]
                  },
                  {
                      "deptName": "血液系統",
                      "deptEName": "Hematology",
                      "examItemList": [
                          {
                              "examName": "鐵蛋白",
                              "examItem": "L3004500",
                              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.48436248,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "血球計數",
                              "examItem": "L5003200",
                              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "330",
                              "rateStatus": true,
                              "abnormalRatio": 0.24270557,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "白血球分類",
                              "examItem": "L5000500",
                              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.10483387,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "纖維蛋白原",
                              "examItem": "L5002600",
                              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "血液系統"
                          }
                      ]
                  },
                  {
                      "deptName": "腎臟泌尿系統",
                      "deptEName": "Kidney and Urology",
                      "examItemList": [
                          {
                              "examName": "腎絲球過濾率",
                              "examItem": "L300150001",
                              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.46638596,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿酸",
                              "examItem": "L3001400",
                              "examMemo": "尿酸檢查可評估痛風及腎功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.3110547,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿液常規檢查",
                              "examItem": "L4002000A",
                              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "170",
                              "rateStatus": true,
                              "abnormalRatio": 0.07999199,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "肌酸酐",
                              "examItem": "L3001500",
                              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.06713337,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "電解質",
                              "examItem": "L3002100A",
                              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "360",
                              "rateStatus": true,
                              "abnormalRatio": 0.054231226,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿素氮",
                              "examItem": "L3001300",
                              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.020641107,
                              "deptName": "腎臟泌尿系統"
                          }
                      ]
                  },
                  {
                      "deptName": "脊椎骨骼系統",
                      "deptEName": "Skeletal System",
                      "examItemList": [
                          {
                              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
                              "examItem": "R1040501A",
                              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "900",
                              "rateStatus": true,
                              "abnormalRatio": 0.83651227,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "腰薦椎正面及側面X光",
                              "examItem": "R1041200A",
                              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.81395346,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "雙膝X光",
                              "examItem": "R1054000A",
                              "examMemo": "雙膝X光主要用於檢查膝關節的骨骼結構、關節腫脹或損傷，協助診斷關節炎、骨折等疾病，確保膝蓋的健康狀態。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.28025478,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "骨鈣素",
                              "examItem": "L3004600",
                              "examMemo": "骨鈣素可評估骨質新生速度，有助了解骨骼健康與骨質疏鬆風險",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "700",
                              "rateStatus": true,
                              "abnormalRatio": 0.24752475,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "左髖關節骨質密度",
                              "examItem": "R1140400A",
                              "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1000",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "脊椎骨骼系統"
                          }
                      ]
                  },
                  {
                      "deptName": "理學檢查",
                      "deptEName": "Physical Examination",
                      "examItemList": [
                          {
                              "examName": "理學檢查",
                              "examItem": "PE00010023A",
                              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.14126594,
                              "deptName": "理學檢查"
                          },
                          {
                              "examName": "個人主訴",
                              "examItem": "HI000001A",
                              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "理學檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "影像醫學",
                      "deptEName": "CT/MRI",
                      "examItemList": [
                          {
                              "examName": "冠狀動脈鈣化積分",
                              "examItem": "R9003800AH",
                              "examMemo": "檢查心臟冠狀動脈鈣化程度，評估心肌梗塞風險（若有裝置心臟支架、心律調節器、人工心臟瓣膜或胸椎打釘，無法排檢）",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "6500",
                              "rateStatus": false,
                              "abnormalRatio": 0.19708535,
                              "deptName": "影像醫學"
                          }
                      ]
                  },
                  {
                      "deptName": "眼科檢查",
                      "deptEName": "Eye Examination",
                      "examItemList": [
                          {
                              "examName": "視力",
                              "examItem": "PE00040001B",
                              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.24298806,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼底斷層掃描",
                              "examItem": "PE000001A",
                              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.22279978,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "石原色覺檢查表",
                              "examItem": "PE00040014",
                              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.049161676,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼壓",
                              "examItem": "PE00040004B",
                              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.042481624,
                              "deptName": "眼科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "消化系統",
                      "deptEName": "Digestive System",
                      "examItemList": [
                          {
                              "examName": "上腹部超音波",
                              "examItem": "R2022000A",
                              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.90277964,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸丙酮酸轉氨基酶",
                              "examItem": "L3000300",
                              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.32915446,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "直接膽紅素",
                              "examItem": "L3001710",
                              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.14638714,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗原",
                              "examItem": "L2001900",
                              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.13758251,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸苯醋酸轉氨基酶",
                              "examItem": "L3000200",
                              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.11648777,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總膽紅素",
                              "examItem": "L3001700",
                              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.114548095,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸轉肽酶",
                              "examItem": "L3000400",
                              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.09633882,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "白蛋白",
                              "examItem": "L3018100",
                              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.056706805,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "鹼性磷酸酶",
                              "examItem": "L3000100",
                              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.023285212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "C型肝炎抗體測定",
                              "examItem": "LG001400",
                              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.009078212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總蛋白",
                              "examItem": "L3001800",
                              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.008030916,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗體",
                              "examItem": "L2002000",
                              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "球蛋白",
                              "examItem": "L301810003",
                              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
                              "examItem": "LB000401Q",
                              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "6500",
                              "rateStatus": true,
                              "abnormalRatio": 0.9862259,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "胃鏡",
                              "examItem": "LB000201C",
                              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "3500",
                              "rateStatus": true,
                              "abnormalRatio": 0.96851075,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "幽門桿菌培養鑑定檢查",
                              "examItem": "LB002600",
                              "examMemo": "幽門桿菌培養鑑定檢查可確認是否感染此細菌，該菌與胃潰瘍及胃炎有關。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "300",
                              "rateStatus": false,
                              "abnormalRatio": 0.29605263,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎核心抗體",
                              "examItem": "L2002300",
                              "examMemo": "B型肝炎核心抗體檢查可判斷是否曾感染B型肝炎病毒，了解個體是否具免疫力或需要進一步檢查，協助評估肝臟健康風險。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.17991632,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "胰澱粉脢",
                              "examItem": "L6000800",
                              "examMemo": "胰澱粉脢是消化酶，主要分解澱粉為葡萄糖。檢查其活性可評估胰腺功能，幫助診斷胰臟炎或其他消化問題。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "220",
                              "rateStatus": true,
                              "abnormalRatio": 0.10427136,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "(新)雙項麻醉",
                              "examItem": "PE001006",
                              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "5800",
                              "rateStatus": false,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          }
                      ]
                  },
                  {
                      "deptName": "神經系統",
                      "deptEName": "Neurology",
                      "examItemList": [
                          {
                              "examName": "HRV自律神經",
                              "examItem": "L1008000A",
                              "examMemo": "HRV自律神經檢查能評估自主神經系統的平衡，反映壓力反應和健康狀態。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1400",
                              "rateStatus": true,
                              "abnormalRatio": 0.7209613,
                              "deptName": "神經系統"
                          }
                      ]
                  }
              ],
              "abnormalCnt": "0",
              "potentialCnt": "33"
          },
          "aiExclusive": {
              "discountRate": "0.73266",
              "packageList": [
                  {
                      "deptName": "一般檢查",
                      "deptEName": "General Examination",
                      "examItemList": [
                          {
                              "examName": "體脂肪率",
                              "examItem": "PE00010019",
                              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6588167,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體質量指數",
                              "examItem": "PE00010006",
                              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6336039,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "腰圍",
                              "examItem": "PE00010017",
                              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.4081422,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "血壓",
                              "examItem": "PE00010009A",
                              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.36203143,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "脈搏",
                              "examItem": "PE00010007A",
                              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.02100955,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "上下肢肌力檢測",
                              "examItem": "MMS001A",
                              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.016194332,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身高",
                              "examItem": "PE00010001",
                              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "200",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "體重",
                              "examItem": "PE00010002",
                              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "理想體重",
                              "examItem": "PE00010003",
                              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體組成分析",
                              "examItem": "PE00010040",
                              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "心血管及代謝系統",
                      "deptEName": "Cardiovascular and Metabolic System",
                      "examItemList": [
                          {
                              "examName": "低密度脂蛋白-膽固醇",
                              "examItem": "L3005200",
                              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "375",
                              "rateStatus": true,
                              "abnormalRatio": 0.6037854,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總膽固醇",
                              "examItem": "L3001900",
                              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.5826974,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高敏感性C反應蛋白",
                              "examItem": "L3018400",
                              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.4319874,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "低/高密度脂蛋白比值",
                              "examItem": "L300350002",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.3974091,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前血糖",
                              "examItem": "L3000800",
                              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.38921002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "靜式心電圖",
                              "examItem": "L1001100A",
                              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "350",
                              "rateStatus": true,
                              "abnormalRatio": 0.3740002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "糖化血色素",
                              "examItem": "L3000700",
                              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.32150638,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "三酸甘油脂",
                              "examItem": "L3002000",
                              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "180",
                              "rateStatus": true,
                              "abnormalRatio": 0.31154653,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總/高密度膽固醇比",
                              "examItem": "L300350001",
                              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.27469006,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高密度脂蛋白-膽固醇",
                              "examItem": "L3003500",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.18991618,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "同半胱胺酸",
                              "examItem": "L3018300",
                              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.15489566,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "脫氫表雄酮硫酸鹽",
                              "examItem": "LI005300",
                              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.0952381,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前胰島素(含阻抗)",
                              "examItem": "LI001700A",
                              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.08467293,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "甲狀腺刺激素",
                              "examItem": "LI000400",
                              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.034355164,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "游離甲狀腺素",
                              "examItem": "LI003400",
                              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.028777989,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "十年心血管疾病風險評估",
                              "examItem": "R401470005",
                              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "全身體脂肪分析",
                              "examItem": "R1140700A",
                              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1200",
                              "rateStatus": true,
                              "abnormalRatio": 0.95320195,
                              "deptName": "心血管及代謝系統"
                          }
                      ]
                  },
                  {
                      "deptName": "腎臟泌尿系統",
                      "deptEName": "Kidney and Urology",
                      "examItemList": [
                          {
                              "examName": "腎絲球過濾率",
                              "examItem": "L300150001",
                              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.46638596,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿酸",
                              "examItem": "L3001400",
                              "examMemo": "尿酸檢查可評估痛風及腎功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.3110547,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿液常規檢查",
                              "examItem": "L4002000A",
                              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "170",
                              "rateStatus": true,
                              "abnormalRatio": 0.07999199,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "肌酸酐",
                              "examItem": "L3001500",
                              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.06713337,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "電解質",
                              "examItem": "L3002100A",
                              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "360",
                              "rateStatus": true,
                              "abnormalRatio": 0.054231226,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿素氮",
                              "examItem": "L3001300",
                              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.020641107,
                              "deptName": "腎臟泌尿系統"
                          }
                      ]
                  },
                  {
                      "deptName": "男性醫學",
                      "deptEName": "Male medicine",
                      "examItemList": [
                          {
                              "examName": "睪固酮",
                              "examItem": "LI001400",
                              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.08185654,
                              "deptName": "男性醫學"
                          }
                      ]
                  },
                  {
                      "deptName": "脊椎骨骼系統",
                      "deptEName": "Skeletal System",
                      "examItemList": [
                          {
                              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
                              "examItem": "R1040501A",
                              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "900",
                              "rateStatus": true,
                              "abnormalRatio": 0.83651227,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "腰薦椎正面及側面X光",
                              "examItem": "R1041200A",
                              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.81395346,
                              "deptName": "脊椎骨骼系統"
                          }
                      ]
                  },
                  {
                      "deptName": "理學檢查",
                      "deptEName": "Physical Examination",
                      "examItemList": [
                          {
                              "examName": "理學檢查",
                              "examItem": "PE00010023A",
                              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.14126594,
                              "deptName": "理學檢查"
                          },
                          {
                              "examName": "個人主訴",
                              "examItem": "HI000001A",
                              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "理學檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "肺部檢查",
                      "deptEName": "Lung Examination",
                      "examItemList": [
                          {
                              "examName": "胸部X光（正面及左側面）",
                              "examItem": "R132001DA",
                              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "720",
                              "rateStatus": true,
                              "abnormalRatio": 0.33959147,
                              "deptName": "肺部檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "耳鼻喉科檢查",
                      "deptEName": "ENT Examination",
                      "examItemList": [
                          {
                              "examName": "聽力檢查",
                              "examItem": "T700110011B",
                              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "250",
                              "rateStatus": true,
                              "abnormalRatio": 0.09931259,
                              "deptName": "耳鼻喉科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "眼科檢查",
                      "deptEName": "Eye Examination",
                      "examItemList": [
                          {
                              "examName": "視力",
                              "examItem": "PE00040001B",
                              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.24298806,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼底斷層掃描",
                              "examItem": "PE000001A",
                              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.22279978,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "石原色覺檢查表",
                              "examItem": "PE00040014",
                              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.049161676,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼壓",
                              "examItem": "PE00040004B",
                              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.042481624,
                              "deptName": "眼科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "營養素與礦物質",
                      "deptEName": "Nutrient & Mineral",
                      "examItemList": [
                          {
                              "examName": "維他命 D",
                              "examItem": "VIT0002",
                              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.88415545,
                              "deptName": "營養素與礦物質"
                          }
                      ]
                  },
                  {
                      "deptName": "消化系統",
                      "deptEName": "Digestive System",
                      "examItemList": [
                          {
                              "examName": "上腹部超音波",
                              "examItem": "R2022000A",
                              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.90277964,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸丙酮酸轉氨基酶",
                              "examItem": "L3000300",
                              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.32915446,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "直接膽紅素",
                              "examItem": "L3001710",
                              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.14638714,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗原",
                              "examItem": "L2001900",
                              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.13758251,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸苯醋酸轉氨基酶",
                              "examItem": "L3000200",
                              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.11648777,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總膽紅素",
                              "examItem": "L3001700",
                              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.114548095,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸轉肽酶",
                              "examItem": "L3000400",
                              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.09633882,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "白蛋白",
                              "examItem": "L3018100",
                              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.056706805,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "鹼性磷酸酶",
                              "examItem": "L3000100",
                              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.023285212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "C型肝炎抗體測定",
                              "examItem": "LG001400",
                              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.009078212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總蛋白",
                              "examItem": "L3001800",
                              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.008030916,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗體",
                              "examItem": "L2002000",
                              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "球蛋白",
                              "examItem": "L301810003",
                              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
                              "examItem": "LB000401Q",
                              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "6500",
                              "rateStatus": true,
                              "abnormalRatio": 0.9862259,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "胃鏡",
                              "examItem": "LB000201C",
                              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "3500",
                              "rateStatus": true,
                              "abnormalRatio": 0.96851075,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "(新)雙項麻醉",
                              "examItem": "PE001006",
                              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "5800",
                              "rateStatus": false,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          }
                      ]
                  },
                  {
                      "deptName": "血液系統",
                      "deptEName": "Hematology",
                      "examItemList": [
                          {
                              "examName": "鐵蛋白",
                              "examItem": "L3004500",
                              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.48436248,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "血球計數",
                              "examItem": "L5003200",
                              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "330",
                              "rateStatus": true,
                              "abnormalRatio": 0.24270557,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "白血球分類",
                              "examItem": "L5000500",
                              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.10483387,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "纖維蛋白原",
                              "examItem": "L5002600",
                              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "血液系統"
                          }
                      ]
                  }
              ],
              "abnormalCnt": "0",
              "potentialCnt": "6"
          },
          "basicCheckup": {
              "discountRate": "0.71326",
              "packageList": [
                  {
                      "deptName": "一般檢查",
                      "deptEName": "General Examination",
                      "examItemList": [
                          {
                              "examName": "上下肢肌力檢測",
                              "examItem": "MMS001A",
                              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.016194332,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身高",
                              "examItem": "PE00010001",
                              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "200",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "體重",
                              "examItem": "PE00010002",
                              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "理想體重",
                              "examItem": "PE00010003",
                              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體質量指數",
                              "examItem": "PE00010006",
                              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6336039,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "脈搏",
                              "examItem": "PE00010007A",
                              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.02100955,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "血壓",
                              "examItem": "PE00010009A",
                              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.36203143,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "腰圍",
                              "examItem": "PE00010017",
                              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.4081422,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "體脂肪率",
                              "examItem": "PE00010019",
                              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6588167,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體組成分析",
                              "examItem": "PE00010040",
                              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "心血管及代謝系統",
                      "deptEName": "Cardiovascular and Metabolic System",
                      "examItemList": [
                          {
                              "examName": "靜式心電圖",
                              "examItem": "L1001100A",
                              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "350",
                              "rateStatus": true,
                              "abnormalRatio": 0.3740002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "糖化血色素",
                              "examItem": "L3000700",
                              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.32150638,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前血糖",
                              "examItem": "L3000800",
                              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.38921002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總膽固醇",
                              "examItem": "L3001900",
                              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.5826974,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "三酸甘油脂",
                              "examItem": "L3002000",
                              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "180",
                              "rateStatus": true,
                              "abnormalRatio": 0.31154653,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高密度脂蛋白-膽固醇",
                              "examItem": "L3003500",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.18991618,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總/高密度膽固醇比",
                              "examItem": "L300350001",
                              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.27469006,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "低/高密度脂蛋白比值",
                              "examItem": "L300350002",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.3974091,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "低密度脂蛋白-膽固醇",
                              "examItem": "L3005200",
                              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "375",
                              "rateStatus": true,
                              "abnormalRatio": 0.6037854,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "同半胱胺酸",
                              "examItem": "L3018300",
                              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.15489566,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高敏感性C反應蛋白",
                              "examItem": "L3018400",
                              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.4319874,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "甲狀腺刺激素",
                              "examItem": "LI000400",
                              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.034355164,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前胰島素(含阻抗)",
                              "examItem": "LI001700A",
                              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.08467293,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "游離甲狀腺素",
                              "examItem": "LI003400",
                              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.028777989,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "脫氫表雄酮硫酸鹽",
                              "examItem": "LI005300",
                              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.0952381,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "十年心血管疾病風險評估",
                              "examItem": "R401470005",
                              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "心血管及代謝系統"
                          }
                      ]
                  },
                  {
                      "deptName": "腎臟泌尿系統",
                      "deptEName": "Kidney and Urology",
                      "examItemList": [
                          {
                              "examName": "尿素氮",
                              "examItem": "L3001300",
                              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.020641107,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿酸",
                              "examItem": "L3001400",
                              "examMemo": "尿酸檢查可評估痛風及腎功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.3110547,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "肌酸酐",
                              "examItem": "L3001500",
                              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.06713337,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "腎絲球過濾率",
                              "examItem": "L300150001",
                              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.46638596,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "電解質",
                              "examItem": "L3002100A",
                              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "360",
                              "rateStatus": true,
                              "abnormalRatio": 0.054231226,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿液常規檢查",
                              "examItem": "L4002000A",
                              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "170",
                              "rateStatus": true,
                              "abnormalRatio": 0.07999199,
                              "deptName": "腎臟泌尿系統"
                          }
                      ]
                  },
                  {
                      "deptName": "男性醫學",
                      "deptEName": "Male medicine",
                      "examItemList": [
                          {
                              "examName": "睪固酮",
                              "examItem": "LI001400",
                              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.08185654,
                              "deptName": "男性醫學"
                          }
                      ]
                  },
                  {
                      "deptName": "理學檢查",
                      "deptEName": "Physical Examination",
                      "examItemList": [
                          {
                              "examName": "個人主訴",
                              "examItem": "HI000001A",
                              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "理學檢查"
                          },
                          {
                              "examName": "理學檢查",
                              "examItem": "PE00010023A",
                              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.14126594,
                              "deptName": "理學檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "肺部檢查",
                      "deptEName": "Lung Examination",
                      "examItemList": [
                          {
                              "examName": "胸部X光（正面及左側面）",
                              "examItem": "R132001DA",
                              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "720",
                              "rateStatus": true,
                              "abnormalRatio": 0.33959147,
                              "deptName": "肺部檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "營養素與礦物質",
                      "deptEName": "Nutrient & Mineral",
                      "examItemList": [
                          {
                              "examName": "維他命 D",
                              "examItem": "VIT0002",
                              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.88415545,
                              "deptName": "營養素與礦物質"
                          }
                      ]
                  },
                  {
                      "deptName": "耳鼻喉科檢查",
                      "deptEName": "ENT Examination",
                      "examItemList": [
                          {
                              "examName": "聽力檢查",
                              "examItem": "T700110011B",
                              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "250",
                              "rateStatus": true,
                              "abnormalRatio": 0.09931259,
                              "deptName": "耳鼻喉科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "眼科檢查",
                      "deptEName": "Eye Examination",
                      "examItemList": [
                          {
                              "examName": "眼底斷層掃描",
                              "examItem": "PE000001A",
                              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.22279978,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "視力",
                              "examItem": "PE00040001B",
                              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.24298806,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼壓",
                              "examItem": "PE00040004B",
                              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.042481624,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "石原色覺檢查表",
                              "examItem": "PE00040014",
                              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.049161676,
                              "deptName": "眼科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "消化系統",
                      "deptEName": "Digestive System",
                      "examItemList": [
                          {
                              "examName": "B型肝炎表面抗原",
                              "examItem": "L2001900",
                              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.13758251,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗體",
                              "examItem": "L2002000",
                              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "鹼性磷酸酶",
                              "examItem": "L3000100",
                              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.023285212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸苯醋酸轉氨基酶",
                              "examItem": "L3000200",
                              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.11648777,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸丙酮酸轉氨基酶",
                              "examItem": "L3000300",
                              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.32915446,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸轉肽酶",
                              "examItem": "L3000400",
                              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.09633882,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總膽紅素",
                              "examItem": "L3001700",
                              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.114548095,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "直接膽紅素",
                              "examItem": "L3001710",
                              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.14638714,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總蛋白",
                              "examItem": "L3001800",
                              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.008030916,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "白蛋白",
                              "examItem": "L3018100",
                              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.056706805,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "球蛋白",
                              "examItem": "L301810003",
                              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "潛血（酵素免疫）",
                              "examItem": "L4002800",
                              "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                              "examType": "優先必要檢查項目",
                              "examPrice": "180",
                              "rateStatus": true,
                              "abnormalRatio": 0.033580706,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "C型肝炎抗體測定",
                              "examItem": "LG001400",
                              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.009078212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "上腹部超音波",
                              "examItem": "R2022000A",
                              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.90277964,
                              "deptName": "消化系統"
                          }
                      ]
                  },
                  {
                      "deptName": "血液系統",
                      "deptEName": "Hematology",
                      "examItemList": [
                          {
                              "examName": "鐵蛋白",
                              "examItem": "L3004500",
                              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.48436248,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "白血球分類",
                              "examItem": "L5000500",
                              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.10483387,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "纖維蛋白原",
                              "examItem": "L5002600",
                              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "血球計數",
                              "examItem": "L5003200",
                              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "330",
                              "rateStatus": true,
                              "abnormalRatio": 0.24270557,
                              "deptName": "血液系統"
                          }
                      ]
                  }
              ],
              "abnormalCnt": "0",
              "potentialCnt": "0"
          }
      },
      "selectedPackage": "智能專屬型",
      "examItemList": [
          {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6588167,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體質量指數",
              "examItem": "PE00010006",
              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6336039,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰圍",
              "examItem": "PE00010017",
              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.4081422,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.36203143,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脈搏",
              "examItem": "PE00010007A",
              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.02100955,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上下肢肌力檢測",
              "examItem": "MMS001A",
              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.016194332,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身高",
              "examItem": "PE00010001",
              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "200",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "體重",
              "examItem": "PE00010002",
              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理想體重",
              "examItem": "PE00010003",
              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體組成分析",
              "examItem": "PE00010040",
              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低密度脂蛋白-膽固醇",
              "examItem": "L3005200",
              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "375",
              "rateStatus": true,
              "abnormalRatio": 0.6037854,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽固醇",
              "examItem": "L3001900",
              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.5826974,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高敏感性C反應蛋白",
              "examItem": "L3018400",
              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.4319874,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低/高密度脂蛋白比值",
              "examItem": "L300350002",
              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.3974091,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前血糖",
              "examItem": "L3000800",
              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.38921002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "350",
              "rateStatus": true,
              "abnormalRatio": 0.3740002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "糖化血色素",
              "examItem": "L3000700",
              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.32150638,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "三酸甘油脂",
              "examItem": "L3002000",
              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "180",
              "rateStatus": true,
              "abnormalRatio": 0.31154653,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總/高密度膽固醇比",
              "examItem": "L300350001",
              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.27469006,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高密度脂蛋白-膽固醇",
              "examItem": "L3003500",
              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.18991618,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "同半胱胺酸",
              "examItem": "L3018300",
              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "800",
              "rateStatus": true,
              "abnormalRatio": 0.15489566,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脫氫表雄酮硫酸鹽",
              "examItem": "LI005300",
              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
              "examType": "優先必要檢查項目",
              "examPrice": "500",
              "rateStatus": true,
              "abnormalRatio": 0.0952381,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前胰島素(含阻抗)",
              "examItem": "LI001700A",
              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0.08467293,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "甲狀腺刺激素",
              "examItem": "LI000400",
              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.034355164,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "游離甲狀腺素",
              "examItem": "LI003400",
              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
              "examType": "優先必要檢查項目",
              "examPrice": "500",
              "rateStatus": true,
              "abnormalRatio": 0.028777989,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "十年心血管疾病風險評估",
              "examItem": "R401470005",
              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "全身體脂肪分析",
              "examItem": "R1140700A",
              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "1200",
              "rateStatus": true,
              "abnormalRatio": 0.95320195,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腎絲球過濾率",
              "examItem": "L300150001",
              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.46638596,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿酸",
              "examItem": "L3001400",
              "examMemo": "尿酸檢查可評估痛風及腎功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.3110547,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿液常規檢查",
              "examItem": "L4002000A",
              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
              "examType": "優先必要檢查項目",
              "examPrice": "170",
              "rateStatus": true,
              "abnormalRatio": 0.07999199,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "肌酸酐",
              "examItem": "L3001500",
              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.06713337,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "電解質",
              "examItem": "L3002100A",
              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
              "examType": "優先必要檢查項目",
              "examPrice": "360",
              "rateStatus": true,
              "abnormalRatio": 0.054231226,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿素氮",
              "examItem": "L3001300",
              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.020641107,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "睪固酮",
              "examItem": "LI001400",
              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "600",
              "rateStatus": true,
              "abnormalRatio": 0.08185654,
              "deptName": "男性醫學",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
              "examItem": "R1040501A",
              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "900",
              "rateStatus": true,
              "abnormalRatio": 0.83651227,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰薦椎正面及側面X光",
              "examItem": "R1041200A",
              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "600",
              "rateStatus": true,
              "abnormalRatio": 0.81395346,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理學檢查",
              "examItem": "PE00010023A",
              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.14126594,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "個人主訴",
              "examItem": "HI000001A",
              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胸部X光（正面及左側面）",
              "examItem": "R132001DA",
              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
              "examType": "優先必要檢查項目",
              "examPrice": "720",
              "rateStatus": true,
              "abnormalRatio": 0.33959147,
              "deptName": "肺部檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "聽力檢查",
              "examItem": "T700110011B",
              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
              "examType": "優先必要檢查項目",
              "examPrice": "250",
              "rateStatus": true,
              "abnormalRatio": 0.09931259,
              "deptName": "耳鼻喉科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "examType": "優先必要檢查項目",
              "examPrice": "50",
              "rateStatus": true,
              "abnormalRatio": 0.24298806,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼底斷層掃描",
              "examItem": "PE000001A",
              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
              "examType": "優先必要檢查項目",
              "examPrice": "1500",
              "rateStatus": true,
              "abnormalRatio": 0.22279978,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "石原色覺檢查表",
              "examItem": "PE00040014",
              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "50",
              "rateStatus": true,
              "abnormalRatio": 0.049161676,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.042481624,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "維他命 D",
              "examItem": "VIT0002",
              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
              "examType": "優先必要檢查項目",
              "examPrice": "800",
              "rateStatus": true,
              "abnormalRatio": 0.88415545,
              "deptName": "營養素與礦物質",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上腹部超音波",
              "examItem": "R2022000A",
              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "1500",
              "rateStatus": true,
              "abnormalRatio": 0.90277964,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸丙酮酸轉氨基酶",
              "examItem": "L3000300",
              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.32915446,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "直接膽紅素",
              "examItem": "L3001710",
              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.14638714,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.13758251,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸苯醋酸轉氨基酶",
              "examItem": "L3000200",
              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.11648777,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽紅素",
              "examItem": "L3001700",
              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.114548095,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸轉肽酶",
              "examItem": "L3000400",
              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.09633882,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白蛋白",
              "examItem": "L3018100",
              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.056706805,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鹼性磷酸酶",
              "examItem": "L3000100",
              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.023285212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "C型肝炎抗體測定",
              "examItem": "LG001400",
              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.009078212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總蛋白",
              "examItem": "L3001800",
              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.008030916,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗體",
              "examItem": "L2002000",
              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "球蛋白",
              "examItem": "L301810003",
              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
              "examItem": "LB000401Q",
              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "6500",
              "rateStatus": true,
              "abnormalRatio": 0.9862259,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胃鏡",
              "examItem": "LB000201C",
              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "3500",
              "rateStatus": true,
              "abnormalRatio": 0.96851075,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "(新)雙項麻醉",
              "examItem": "PE001006",
              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "5800",
              "rateStatus": false,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鐵蛋白",
              "examItem": "L3004500",
              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0.48436248,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血球計數",
              "examItem": "L5003200",
              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.24270557,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白血球分類",
              "examItem": "L5000500",
              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.10483387,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "纖維蛋白原",
              "examItem": "L5002600",
              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          }
      ],
      "packagePrice": "26410",
      "originalPrice": 26410,
      "discountRate": "0.73266",
      "selectedPackagePlanType": "2",
      "aiChatbotExamItemList": [
          {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6588167,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體質量指數",
              "examItem": "PE00010006",
              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6336039,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰圍",
              "examItem": "PE00010017",
              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.4081422,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.36203143,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脈搏",
              "examItem": "PE00010007A",
              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.02100955,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上下肢肌力檢測",
              "examItem": "MMS001A",
              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0.016194332,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身高",
              "examItem": "PE00010001",
              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "150",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "體重",
              "examItem": "PE00010002",
              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理想體重",
              "examItem": "PE00010003",
              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體組成分析",
              "examItem": "PE00010040",
              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低密度脂蛋白-膽固醇",
              "examItem": "L3005200",
              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "280",
              "rateStatus": true,
              "abnormalRatio": 0.6037854,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽固醇",
              "examItem": "L3001900",
              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0.5826974,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高敏感性C反應蛋白",
              "examItem": "L3018400",
              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0.4319874,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低/高密度脂蛋白比值",
              "examItem": "L300350002",
              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.3974091,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前血糖",
              "examItem": "L3000800",
              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.38921002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "260",
              "rateStatus": true,
              "abnormalRatio": 0.3740002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "糖化血色素",
              "examItem": "L3000700",
              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0.32150638,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "三酸甘油脂",
              "examItem": "L3002000",
              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "140",
              "rateStatus": true,
              "abnormalRatio": 0.31154653,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總/高密度膽固醇比",
              "examItem": "L300350001",
              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.27469006,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高密度脂蛋白-膽固醇",
              "examItem": "L3003500",
              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0.18991618,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "同半胱胺酸",
              "examItem": "L3018300",
              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "590",
              "rateStatus": true,
              "abnormalRatio": 0.15489566,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脫氫表雄酮硫酸鹽",
              "examItem": "LI005300",
              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
              "examType": "優先必要檢查項目",
              "examPrice": "370",
              "rateStatus": true,
              "abnormalRatio": 0.0952381,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前胰島素(含阻抗)",
              "examItem": "LI001700A",
              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.08467293,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "甲狀腺刺激素",
              "examItem": "LI000400",
              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.034355164,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "游離甲狀腺素",
              "examItem": "LI003400",
              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
              "examType": "優先必要檢查項目",
              "examPrice": "370",
              "rateStatus": true,
              "abnormalRatio": 0.028777989,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "十年心血管疾病風險評估",
              "examItem": "R401470005",
              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "全身體脂肪分析",
              "examItem": "R1140700A",
              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "880",
              "rateStatus": true,
              "abnormalRatio": 0.95320195,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腎絲球過濾率",
              "examItem": "L300150001",
              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.46638596,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿酸",
              "examItem": "L3001400",
              "examMemo": "尿酸檢查可評估痛風及腎功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.3110547,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿液常規檢查",
              "examItem": "L4002000A",
              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
              "examType": "優先必要檢查項目",
              "examPrice": "130",
              "rateStatus": true,
              "abnormalRatio": 0.07999199,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "肌酸酐",
              "examItem": "L3001500",
              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.06713337,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "電解質",
              "examItem": "L3002100A",
              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
              "examType": "優先必要檢查項目",
              "examPrice": "270",
              "rateStatus": true,
              "abnormalRatio": 0.054231226,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿素氮",
              "examItem": "L3001300",
              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.020641107,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "睪固酮",
              "examItem": "LI001400",
              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "440",
              "rateStatus": true,
              "abnormalRatio": 0.08185654,
              "deptName": "男性醫學",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
              "examItem": "R1040501A",
              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "660",
              "rateStatus": true,
              "abnormalRatio": 0.83651227,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰薦椎正面及側面X光",
              "examItem": "R1041200A",
              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "440",
              "rateStatus": true,
              "abnormalRatio": 0.81395346,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理學檢查",
              "examItem": "PE00010023A",
              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.14126594,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "個人主訴",
              "examItem": "HI000001A",
              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胸部X光（正面及左側面）",
              "examItem": "R132001DA",
              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
              "examType": "優先必要檢查項目",
              "examPrice": "530",
              "rateStatus": true,
              "abnormalRatio": 0.33959147,
              "deptName": "肺部檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "聽力檢查",
              "examItem": "T700110011B",
              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
              "examType": "優先必要檢查項目",
              "examPrice": "190",
              "rateStatus": true,
              "abnormalRatio": 0.09931259,
              "deptName": "耳鼻喉科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "examType": "優先必要檢查項目",
              "examPrice": "40",
              "rateStatus": true,
              "abnormalRatio": 0.24298806,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼底斷層掃描",
              "examItem": "PE000001A",
              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
              "examType": "優先必要檢查項目",
              "examPrice": "1100",
              "rateStatus": true,
              "abnormalRatio": 0.22279978,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "石原色覺檢查表",
              "examItem": "PE00040014",
              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "40",
              "rateStatus": true,
              "abnormalRatio": 0.049161676,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0.042481624,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "維他命 D",
              "examItem": "VIT0002",
              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
              "examType": "優先必要檢查項目",
              "examPrice": "590",
              "rateStatus": true,
              "abnormalRatio": 0.88415545,
              "deptName": "營養素與礦物質",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上腹部超音波",
              "examItem": "R2022000A",
              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "1100",
              "rateStatus": true,
              "abnormalRatio": 0.90277964,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸丙酮酸轉氨基酶",
              "examItem": "L3000300",
              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.32915446,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "直接膽紅素",
              "examItem": "L3001710",
              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.14638714,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0.13758251,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸苯醋酸轉氨基酶",
              "examItem": "L3000200",
              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.11648777,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽紅素",
              "examItem": "L3001700",
              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.114548095,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸轉肽酶",
              "examItem": "L3000400",
              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.09633882,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白蛋白",
              "examItem": "L3018100",
              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.056706805,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鹼性磷酸酶",
              "examItem": "L3000100",
              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.023285212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "C型肝炎抗體測定",
              "examItem": "LG001400",
              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.009078212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總蛋白",
              "examItem": "L3001800",
              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.008030916,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗體",
              "examItem": "L2002000",
              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "球蛋白",
              "examItem": "L301810003",
              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
              "examItem": "LB000401Q",
              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "4770",
              "rateStatus": true,
              "abnormalRatio": 0.9862259,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胃鏡",
              "examItem": "LB000201C",
              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "2570",
              "rateStatus": true,
              "abnormalRatio": 0.96851075,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "(新)雙項麻醉",
              "examItem": "PE001006",
              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "5800",
              "rateStatus": false,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鐵蛋白",
              "examItem": "L3004500",
              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.48436248,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血球計數",
              "examItem": "L5003200",
              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "250",
              "rateStatus": true,
              "abnormalRatio": 0.24270557,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白血球分類",
              "examItem": "L5000500",
              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0.10483387,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "纖維蛋白原",
              "examItem": "L5002600",
              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          }
      ],
      "paymentAmount": 26410,
      "mutexItems": {},
      "addExamItemList": [],
      "removeItemQuestionMap": [],
      "originalExamItemList": [
          {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6588167,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體質量指數",
              "examItem": "PE00010006",
              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6336039,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰圍",
              "examItem": "PE00010017",
              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.4081422,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.36203143,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脈搏",
              "examItem": "PE00010007A",
              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.02100955,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上下肢肌力檢測",
              "examItem": "MMS001A",
              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.016194332,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身高",
              "examItem": "PE00010001",
              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "200",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "體重",
              "examItem": "PE00010002",
              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理想體重",
              "examItem": "PE00010003",
              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體組成分析",
              "examItem": "PE00010040",
              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低密度脂蛋白-膽固醇",
              "examItem": "L3005200",
              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "375",
              "rateStatus": true,
              "abnormalRatio": 0.6037854,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽固醇",
              "examItem": "L3001900",
              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.5826974,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高敏感性C反應蛋白",
              "examItem": "L3018400",
              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.4319874,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低/高密度脂蛋白比值",
              "examItem": "L300350002",
              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.3974091,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前血糖",
              "examItem": "L3000800",
              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.38921002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "350",
              "rateStatus": true,
              "abnormalRatio": 0.3740002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "糖化血色素",
              "examItem": "L3000700",
              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.32150638,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "三酸甘油脂",
              "examItem": "L3002000",
              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "180",
              "rateStatus": true,
              "abnormalRatio": 0.31154653,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總/高密度膽固醇比",
              "examItem": "L300350001",
              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.27469006,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高密度脂蛋白-膽固醇",
              "examItem": "L3003500",
              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.18991618,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "同半胱胺酸",
              "examItem": "L3018300",
              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "800",
              "rateStatus": true,
              "abnormalRatio": 0.15489566,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脫氫表雄酮硫酸鹽",
              "examItem": "LI005300",
              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
              "examType": "優先必要檢查項目",
              "examPrice": "500",
              "rateStatus": true,
              "abnormalRatio": 0.0952381,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前胰島素(含阻抗)",
              "examItem": "LI001700A",
              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0.08467293,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "甲狀腺刺激素",
              "examItem": "LI000400",
              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.034355164,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "游離甲狀腺素",
              "examItem": "LI003400",
              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
              "examType": "優先必要檢查項目",
              "examPrice": "500",
              "rateStatus": true,
              "abnormalRatio": 0.028777989,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "十年心血管疾病風險評估",
              "examItem": "R401470005",
              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "全身體脂肪分析",
              "examItem": "R1140700A",
              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "1200",
              "rateStatus": true,
              "abnormalRatio": 0.95320195,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腎絲球過濾率",
              "examItem": "L300150001",
              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.46638596,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿酸",
              "examItem": "L3001400",
              "examMemo": "尿酸檢查可評估痛風及腎功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.3110547,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿液常規檢查",
              "examItem": "L4002000A",
              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
              "examType": "優先必要檢查項目",
              "examPrice": "170",
              "rateStatus": true,
              "abnormalRatio": 0.07999199,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "肌酸酐",
              "examItem": "L3001500",
              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.06713337,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "電解質",
              "examItem": "L3002100A",
              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
              "examType": "優先必要檢查項目",
              "examPrice": "360",
              "rateStatus": true,
              "abnormalRatio": 0.054231226,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿素氮",
              "examItem": "L3001300",
              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.020641107,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "睪固酮",
              "examItem": "LI001400",
              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "600",
              "rateStatus": true,
              "abnormalRatio": 0.08185654,
              "deptName": "男性醫學",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
              "examItem": "R1040501A",
              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "900",
              "rateStatus": true,
              "abnormalRatio": 0.83651227,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰薦椎正面及側面X光",
              "examItem": "R1041200A",
              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "600",
              "rateStatus": true,
              "abnormalRatio": 0.81395346,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理學檢查",
              "examItem": "PE00010023A",
              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.14126594,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "個人主訴",
              "examItem": "HI000001A",
              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胸部X光（正面及左側面）",
              "examItem": "R132001DA",
              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
              "examType": "優先必要檢查項目",
              "examPrice": "720",
              "rateStatus": true,
              "abnormalRatio": 0.33959147,
              "deptName": "肺部檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "聽力檢查",
              "examItem": "T700110011B",
              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
              "examType": "優先必要檢查項目",
              "examPrice": "250",
              "rateStatus": true,
              "abnormalRatio": 0.09931259,
              "deptName": "耳鼻喉科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "examType": "優先必要檢查項目",
              "examPrice": "50",
              "rateStatus": true,
              "abnormalRatio": 0.24298806,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼底斷層掃描",
              "examItem": "PE000001A",
              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
              "examType": "優先必要檢查項目",
              "examPrice": "1500",
              "rateStatus": true,
              "abnormalRatio": 0.22279978,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "石原色覺檢查表",
              "examItem": "PE00040014",
              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "50",
              "rateStatus": true,
              "abnormalRatio": 0.049161676,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.042481624,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "維他命 D",
              "examItem": "VIT0002",
              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
              "examType": "優先必要檢查項目",
              "examPrice": "800",
              "rateStatus": true,
              "abnormalRatio": 0.88415545,
              "deptName": "營養素與礦物質",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上腹部超音波",
              "examItem": "R2022000A",
              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "1500",
              "rateStatus": true,
              "abnormalRatio": 0.90277964,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸丙酮酸轉氨基酶",
              "examItem": "L3000300",
              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.32915446,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "直接膽紅素",
              "examItem": "L3001710",
              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.14638714,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.13758251,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸苯醋酸轉氨基酶",
              "examItem": "L3000200",
              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.11648777,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽紅素",
              "examItem": "L3001700",
              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.114548095,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸轉肽酶",
              "examItem": "L3000400",
              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.09633882,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白蛋白",
              "examItem": "L3018100",
              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.056706805,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鹼性磷酸酶",
              "examItem": "L3000100",
              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.023285212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "C型肝炎抗體測定",
              "examItem": "LG001400",
              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.009078212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總蛋白",
              "examItem": "L3001800",
              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.008030916,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗體",
              "examItem": "L2002000",
              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "球蛋白",
              "examItem": "L301810003",
              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
              "examItem": "LB000401Q",
              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "6500",
              "rateStatus": true,
              "abnormalRatio": 0.9862259,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胃鏡",
              "examItem": "LB000201C",
              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "3500",
              "rateStatus": true,
              "abnormalRatio": 0.96851075,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "(新)雙項麻醉",
              "examItem": "PE001006",
              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "5800",
              "rateStatus": false,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鐵蛋白",
              "examItem": "L3004500",
              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0.48436248,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血球計數",
              "examItem": "L5003200",
              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.24270557,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白血球分類",
              "examItem": "L5000500",
              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.10483387,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "纖維蛋白原",
              "examItem": "L5002600",
              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          }
      ],
      "lastSessionId": "210f3563-88bf-4ce4-9b59-fbeb9c692edd"
    }

    }
    // 企業
    else if (reserveType === '2') {
      dirtyData = {
    "homeShowAnimation": false,
    "myReservation": {
        "flowCode": "0",
        "bookStatus": "",
        "diffDates": 0,
        "bookDate": "",
        "caseNo": "",
        "companyNo": "",
        "familyFlag": ""
    },
    "loginStatus": "memberLogin",
    "createMemberRequest": {
        "gender": "M",
        "birthday": "19770707",
        "name": "黃育芯",
        "idNo": "A282568744",
        "cell": "0939696767",
        "email": "uuu@uu44.com",
        "password": "",
        "confirmPassword": "",
        "chartNo": "8002109631"
    },
    "reserveType": "2",
    "businessLoginInfo": {
        "companyNo": "30041",
        "empId": "95599111",
        "identity": "2"
    },
    "userPlanRequest": {
        "orgNo": "05",
        "gender": "M",
        "birthday": "19770707",
        "age": "48",
        "idNo": "A282568744",
        "name": "黃育芯",
        "cell": "",
        "email": "",
        "telH": "",
        "telO": "",
        "zipCode": "",
        "history": [
            "既往病史_以下皆無"
        ],
        "family": [
            "家族病史_以下皆無"
        ],
        "subjectiveSymptoms": [
            "自覺症狀_以下皆無"
        ],
        "identityType": "0",
        "funcType": "0",
        "femaleStatus": false,
        "femaleMenopausal": false
    },
    "businessPlanRequest": {
        "orgNo": "05",
        "employeeId": "95599111",
        "companyNo": "30041",
        "gender": "M"
    },
    "reserveStep": 5,
    "hasFilledReserveInfo": true,
    "tempPersonalDiseaseDetails": {},
    "tempPersonalDiseaseCheck": {
        "questionId": "474",
        "questionAnswers": [
            {
                "choiceId": "1540",
                "answer": "1"
            }
        ]
    },
    "tempPersonalNoneOfFollowing": true,
    "tempFamilyDiseaseCheck": {
        "questionId": "483",
        "questionAnswers": [
            {
                "choiceId": "1592",
                "answer": "1"
            }
        ]
    },
    "tempFamilyNoneOfFollowing": true,
    "tempSubjectiveSymptomDiseaseCheck": {
        "questionId": "472",
        "questionAnswers": [
            {
                "choiceId": "1510",
                "answer": "1"
            }
        ]
    },
    "tempSubjectiveSymptomNoneOfFollowing": true,
    "currentHealthStep": 3,
    "questionnaireChecks": [
        {
            "questionId": "474",
            "questionAnswers": [
                {
                    "choiceId": "1540",
                    "answer": "1"
                }
            ]
        },
        {
            "questionId": "483",
            "questionAnswers": [
                {
                    "choiceId": "1592",
                    "answer": "1"
                }
            ]
        },
        {
            "questionId": "472",
            "questionAnswers": [
                {
                    "choiceId": "1510",
                    "answer": "1"
                }
            ]
        }
    ],
    "businessPlanResponse": {
        "companyInfo": {
            "companyName": "30041公司",
            "bookableDateE": "20261231",
            "sponsorAmt": "4999"
        },
        "packageList": [
            {
                "packageName": "中興工程公司(114-115年)侵入性(無健檢服)(男)32000(全)",
                "packageNo": "300410026",
                "price": "32000.00000",
                "dayType": "2",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": true,
                "deptList": [
                    {
                        "deptName": "神經系統(Neurology)",
                        "deptEName": "Neuro",
                        "examItemList": [
                            {
                                "examItem": "L1008000A",
                                "examName": "HRV自律神經",
                                "examMemo": "HRV自律神經檢查能評估自主神經系統的平衡，反映壓力反應和健康狀態。",
                                "deptName": "神經系統",
                                "deptEName": "Neurology"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "LB000201C",
                                "examName": "胃鏡",
                                "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "PE001000",
                                "examName": "麻醉(套檢)",
                                "examMemo": "若有BMI大於35以上、呼吸中止症、麻醉過敏或疑慮，請諮詢您的醫師並致電客服",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L6000800",
                                "examName": "胰澱粉酶",
                                "examMemo": "胰澱粉脢是消化酶，主要分解澱粉為葡萄糖。檢查其活性可評估胰腺功能，幫助診斷胰臟炎或其他消化問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "LB000401P",
                                "examName": "(套檢A)NBI大腸鏡-含代餐包",
                                "examMemo": "利用NBI窄頻影像內視鏡系統及CO2充氣系統，進行全段大腸 乙狀結腸 直腸檢查，評估有無瘜肉 腫瘤 痔瘡等異常。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R1010100A",
                                "examName": "胸部X光（正面）",
                                "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "男性醫學(Male medicine)",
                        "deptEName": "Male",
                        "examItemList": [
                            {
                                "examItem": "LI001400",
                                "examName": "睪固酮",
                                "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                                "deptName": "男性醫學",
                                "deptEName": "Male medicine"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110051A",
                                "examName": "密閉式純音聽力檢查",
                                "examMemo": "密閉式純音聽力檢查可評估個人聽力狀況，幫助識別聽力損傷。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "風濕免疫系統(Rheumatology and Immunology )",
                        "deptEName": "Rheuma",
                        "examItemList": [
                            {
                                "examItem": "L2000600",
                                "examName": "類風濕性關節炎因子",
                                "examMemo": "類風濕性關節炎因子（RF）是檢測類風濕性關節炎的指標，高可能表示免疫系統異常，導致關節炎症。檢查RF有助於早期診斷與治療。",
                                "deptName": "風濕免疫系統",
                                "deptEName": "Rheumatology and Immunology"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1040300A",
                                "examName": "頸椎X光",
                                "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "L3004600",
                                "examName": "骨鈣素",
                                "examMemo": "骨鈣素可評估骨質新生速度，有助了解骨骼健康與骨質疏鬆風險",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE000001A",
                                "examName": "眼底斷層掃描",
                                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI003400",
                                "examName": "游離甲狀腺素",
                                "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI006900A",
                                "examName": "游離前列腺特異抗原",
                                "examMemo": "攝護腺病變篩檢參考指標",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "F00000020",
                                "examName": "影像接駁交通費",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "NC000109",
                                "examName": "(套檢)報告諮詢",
                                "examMemo": "專科醫師一對一報告諮詢",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000002",
                                "examName": "午餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [
                    {
                        "groupTitleName": "檢項 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "examItemList": [
                            {
                                "examItem": "R9003800A",
                                "examName": "(套檢)冠狀動脈鈣化積分",
                                "examMemo": "檢查心臟冠狀動脈鈣化程度，評估心肌梗塞風險（若有裝置心臟支架、心律調節器、人工心臟瓣膜或胸椎打釘，無法排檢）",
                                "deptName": "影像醫學",
                                "deptEName": "CT/MRI"
                            },
                            {
                                "examItem": "R9003900A",
                                "examName": "(套檢)低劑量肺部電腦斷層",
                                "examMemo": "篩檢早期肺癌最佳利器！能精確檢查肺部有無腫瘤、肺炎、肉芽腫或纖維化等異常",
                                "deptName": "影像醫學",
                                "deptEName": "CT/MRI"
                            }
                        ]
                    }
                ],
                "groupChooseList": []
            },
            {
                "packageName": "中興工程公司(114-115年)心血管(無健檢服)(男)16000(全)",
                "packageNo": "300410016",
                "price": "16000.00000",
                "dayType": "2",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": true,
                "deptList": [
                    {
                        "deptName": "神經系統(Neurology)",
                        "deptEName": "Neuro",
                        "examItemList": [
                            {
                                "examItem": "L1008000A",
                                "examName": "HRV自律神經",
                                "examMemo": "HRV自律神經檢查能評估自主神經系統的平衡，反映壓力反應和健康狀態。",
                                "deptName": "神經系統",
                                "deptEName": "Neurology"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L4002800",
                                "examName": "潛血（酵素免疫）",
                                "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L6000800",
                                "examName": "胰澱粉酶",
                                "examMemo": "胰澱粉脢是消化酶，主要分解澱粉為葡萄糖。檢查其活性可評估胰腺功能，幫助診斷胰臟炎或其他消化問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "L1001400A",
                                "examName": "肺功能檢查",
                                "examMemo": "肺功能檢查評估肺部的呼吸能力，幫助診斷慢性阻塞性肺病等疾病，及早發現問題可改善呼吸健康。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            },
                            {
                                "examItem": "R132001DA",
                                "examName": "胸部X光（正面及左側面）",
                                "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "男性醫學(Male medicine)",
                        "deptEName": "Male",
                        "examItemList": [
                            {
                                "examItem": "LI001400",
                                "examName": "睪固酮",
                                "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                                "deptName": "男性醫學",
                                "deptEName": "Male medicine"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110051A",
                                "examName": "密閉式純音聽力檢查",
                                "examMemo": "密閉式純音聽力檢查可評估個人聽力狀況，幫助識別聽力損傷。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1040300A",
                                "examName": "頸椎X光",
                                "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3002100A",
                                "examName": "電解質",
                                "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE000001A",
                                "examName": "眼底斷層掃描",
                                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4011700A",
                                "examName": "心臟超音波",
                                "examMemo": "心臟超音波能無痛檢查心臟結構與功能，評估心臟疾病風險、瓣膜狀況及血流，幫助早期發現問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L6001500",
                                "examName": "肌酸磷化酶同功酶MB型",
                                "examMemo": "肌酸磷化酶-MB同功酶（CK-MB）是心肌損傷的指標。檢查CK-MB有助於早期診斷心臟疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI007500",
                                "examName": "前腦排鈉利尿胜肽",
                                "examMemo": "前腦排鈉利尿胜肽（BNP）是心臟細胞釋出的激素，當心臟功能變弱或有衰竭傾向時，BNP 會上升，因此是評估心臟衰竭的重要指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R2026000A",
                                "examName": "甲狀腺超音波",
                                "examMemo": "透過影像檢查甲狀腺的大小、形狀以及是否有結節或其他異常變化。常搭配血液檢驗（如TSH、T3、T4）一同評估甲狀腺健康狀況。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018300",
                                "examName": "同半胱胺酸",
                                "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000600",
                                "examName": "皮質素(08:30AM前報到)",
                                "examMemo": "皮質素是評估腎上腺功能的重要指標，與身體應對壓力，調節血糖、血壓及免疫系統有關",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014700A",
                                "examName": "頸動脈超音波",
                                "examMemo": "頸動脈超音波檢查可以評估頸部血管的狀況，發現動脈硬化或斑塊，幫助預防中風及心血管疾病的風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI006900A",
                                "examName": "游離前列腺特異抗原",
                                "examMemo": "攝護腺病變篩檢參考指標",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI001600",
                                "examName": "癌胚胎抗原",
                                "examMemo": "癌胚胎抗原（CEA）是血液中的腫瘤標記物，常用於篩檢評估大腸直腸癌及其他特定癌症的風險",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "L2004200A",
                                "examName": "EB病毒抗體IgA",
                                "examMemo": "EB病毒抗體IgA檢查評估是否感染EB病毒，常用於鼻咽癌高風險族群的初步篩檢",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "NC000109",
                                "examName": "(套檢)報告諮詢",
                                "examMemo": "專科醫師一對一報告諮詢",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000002",
                                "examName": "午餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [],
                "groupChooseList": []
            },
            {
                "packageName": "中興工程公司(114-115年)高階影像(無健檢服)(男)24000(全)",
                "packageNo": "300410024",
                "price": "24000.00000",
                "dayType": "2",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": true,
                "deptList": [
                    {
                        "deptName": "神經系統(Neurology)",
                        "deptEName": "Neuro",
                        "examItemList": [
                            {
                                "examItem": "L1008000A",
                                "examName": "HRV自律神經",
                                "examMemo": "HRV自律神經檢查能評估自主神經系統的平衡，反映壓力反應和健康狀態。",
                                "deptName": "神經系統",
                                "deptEName": "Neurology"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L2001900",
                                "examName": "B型肝炎表面抗原",
                                "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L4002800",
                                "examName": "潛血（酵素免疫）",
                                "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L2002000",
                                "examName": "B型肝炎表面抗體",
                                "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R1010100A",
                                "examName": "胸部X光（正面）",
                                "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "男性醫學(Male medicine)",
                        "deptEName": "Male",
                        "examItemList": [
                            {
                                "examItem": "LI001400",
                                "examName": "睪固酮",
                                "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                                "deptName": "男性醫學",
                                "deptEName": "Male medicine"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110051A",
                                "examName": "密閉式純音聽力檢查",
                                "examMemo": "密閉式純音聽力檢查可評估個人聽力狀況，幫助識別聽力損傷。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "營養素與礦物質(Nutrient & Mineral )",
                        "deptEName": "NUT",
                        "examItemList": [
                            {
                                "examItem": "VIT0004",
                                "examName": "鋅(血中鋅專用管)",
                                "examMemo": "鋅是支持免疫系統與組織修復的重要營養素，檢查可了解身體的營養與免疫功能狀態。",
                                "deptName": "營養素與礦物質",
                                "deptEName": "Nutrient & Mineral"
                            }
                        ]
                    },
                    {
                        "deptName": "風濕免疫系統(Rheumatology and Immunology )",
                        "deptEName": "Rheuma",
                        "examItemList": [
                            {
                                "examItem": "L2000600",
                                "examName": "類風濕性關節炎因子",
                                "examMemo": "類風濕性關節炎因子（RF）是檢測類風濕性關節炎的指標，高可能表示免疫系統異常，導致關節炎症。檢查RF有助於早期診斷與治療。",
                                "deptName": "風濕免疫系統",
                                "deptEName": "Rheumatology and Immunology"
                            },
                            {
                                "examItem": "L2001300",
                                "examName": "全免疫球蛋白E定量",
                                "examMemo": "全免疫球蛋白E（IgE）定量可評估過敏反應及免疫系統狀況，IgE高可能有過敏、氣喘。",
                                "deptName": "風濕免疫系統",
                                "deptEName": "Rheumatology and Immunology"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1040300A",
                                "examName": "頸椎X光",
                                "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3002100A",
                                "examName": "電解質",
                                "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE000001A",
                                "examName": "眼底斷層掃描",
                                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI003400",
                                "examName": "游離甲狀腺素",
                                "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000500",
                                "examName": "乳酸脫氫酶",
                                "examMemo": "乳酸脫氫酶是身體細胞損傷的指標，升高可能與組織受損、發炎或疾病有關",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014700A",
                                "examName": "頸動脈超音波",
                                "examMemo": "頸動脈超音波檢查可以評估頸部血管的狀況，發現動脈硬化或斑塊，幫助預防中風及心血管疾病的風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI006300",
                                "examName": "CYFRA 21-1腫瘤標記",
                                "examMemo": "CYFRA 21-1是肺部腫瘤參考指標，可作為肺癌追蹤監測與輔助診斷",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI001600",
                                "examName": "癌胚胎抗原",
                                "examMemo": "癌胚胎抗原（CEA）是血液中的腫瘤標記物，常用於篩檢評估大腸直腸癌及其他特定癌症的風險",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "L2004200A",
                                "examName": "EB病毒抗體IgA",
                                "examMemo": "EB病毒抗體IgA檢查評估是否感染EB病毒，常用於鼻咽癌高風險族群的初步篩檢",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "F00000020",
                                "examName": "影像接駁交通費",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "NC000109",
                                "examName": "(套檢)報告諮詢",
                                "examMemo": "專科醫師一對一報告諮詢",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000002",
                                "examName": "午餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [
                    {
                        "groupTitleName": "檢項 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "examItemList": [
                            {
                                "examItem": "R2053000",
                                "examName": "碳-13幽門桿菌呼氣試驗",
                                "examMemo": "碳-13幽門桿菌呼氣試驗能檢測胃中是否有幽門桿菌感染，這種細菌與胃炎和胃潰瘍有關，檢查結果可幫助診斷與治療胃病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "NC000002",
                                "examName": "(限內湖)營養諮詢",
                                "examMemo": "專業營養師一對一諮詢，針對個人身體狀況提供飲食衛教及建議",
                                "deptName": "營養素與礦物質",
                                "deptEName": "Nutrient & Mineral"
                            }
                        ]
                    },
                    {
                        "groupTitleName": "檢項 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "examItemList": [
                            {
                                "examItem": "R9003800A",
                                "examName": "(套檢)冠狀動脈鈣化積分",
                                "examMemo": "檢查心臟冠狀動脈鈣化程度，評估心肌梗塞風險（若有裝置心臟支架、心律調節器、人工心臟瓣膜或胸椎打釘，無法排檢）",
                                "deptName": "影像醫學",
                                "deptEName": "CT/MRI"
                            },
                            {
                                "examItem": "R9003900A",
                                "examName": "(套檢)低劑量肺部電腦斷層",
                                "examMemo": "篩檢早期肺癌最佳利器！能精確檢查肺部有無腫瘤、肺炎、肉芽腫或纖維化等異常",
                                "deptName": "影像醫學",
                                "deptEName": "CT/MRI"
                            }
                        ]
                    }
                ],
                "groupChooseList": []
            },
            {
                "packageName": "中興工程公司(114-115年)心血管(無健檢服)(男)24000(全)",
                "packageNo": "300410022",
                "price": "24000.00000",
                "dayType": "2",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": true,
                "deptList": [
                    {
                        "deptName": "神經系統(Neurology)",
                        "deptEName": "Neuro",
                        "examItemList": [
                            {
                                "examItem": "L1008000A",
                                "examName": "HRV自律神經",
                                "examMemo": "HRV自律神經檢查能評估自主神經系統的平衡，反映壓力反應和健康狀態。",
                                "deptName": "神經系統",
                                "deptEName": "Neurology"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L2001900",
                                "examName": "B型肝炎表面抗原",
                                "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L4002800",
                                "examName": "潛血（酵素免疫）",
                                "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L2002000",
                                "examName": "B型肝炎表面抗體",
                                "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R132001DA",
                                "examName": "胸部X光（正面及左側面）",
                                "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "功能醫學(Functional Medicine)",
                        "deptEName": "FM",
                        "examItemList": [
                            {
                                "examItem": "FM000011A",
                                "examName": "心血管危險因子分析",
                                "examMemo": "",
                                "deptName": "功能醫學",
                                "deptEName": "Functional Medicine"
                            }
                        ]
                    },
                    {
                        "deptName": "男性醫學(Male medicine)",
                        "deptEName": "Male",
                        "examItemList": [
                            {
                                "examItem": "LI001400",
                                "examName": "睪固酮",
                                "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                                "deptName": "男性醫學",
                                "deptEName": "Male medicine"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110051A",
                                "examName": "密閉式純音聽力檢查",
                                "examMemo": "密閉式純音聽力檢查可評估個人聽力狀況，幫助識別聽力損傷。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "營養素與礦物質(Nutrient & Mineral )",
                        "deptEName": "NUT",
                        "examItemList": [
                            {
                                "examItem": "VIT0002",
                                "examName": "維他命 D",
                                "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
                                "deptName": "營養素與礦物質",
                                "deptEName": "Nutrient & Mineral"
                            },
                            {
                                "examItem": "VIT0004",
                                "examName": "鋅(血中鋅專用管)",
                                "examMemo": "鋅是支持免疫系統與組織修復的重要營養素，檢查可了解身體的營養與免疫功能狀態。",
                                "deptName": "營養素與礦物質",
                                "deptEName": "Nutrient & Mineral"
                            }
                        ]
                    },
                    {
                        "deptName": "風濕免疫系統(Rheumatology and Immunology )",
                        "deptEName": "Rheuma",
                        "examItemList": [
                            {
                                "examItem": "L2000600",
                                "examName": "類風濕性關節炎因子",
                                "examMemo": "類風濕性關節炎因子（RF）是檢測類風濕性關節炎的指標，高可能表示免疫系統異常，導致關節炎症。檢查RF有助於早期診斷與治療。",
                                "deptName": "風濕免疫系統",
                                "deptEName": "Rheumatology and Immunology"
                            },
                            {
                                "examItem": "L2001300",
                                "examName": "全免疫球蛋白E定量",
                                "examMemo": "全免疫球蛋白E（IgE）定量可評估過敏反應及免疫系統狀況，IgE高可能有過敏、氣喘。",
                                "deptName": "風濕免疫系統",
                                "deptEName": "Rheumatology and Immunology"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1040300A",
                                "examName": "頸椎X光",
                                "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "L3004600",
                                "examName": "骨鈣素",
                                "examMemo": "骨鈣素可評估骨質新生速度，有助了解骨骼健康與骨質疏鬆風險",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3002100A",
                                "examName": "電解質",
                                "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE000001A",
                                "examName": "眼底斷層掃描",
                                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R1140700A",
                                "examName": "全身體脂肪分析",
                                "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4011700A",
                                "examName": "心臟超音波",
                                "examMemo": "心臟超音波能無痛檢查心臟結構與功能，評估心臟疾病風險、瓣膜狀況及血流，幫助早期發現問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI003400",
                                "examName": "游離甲狀腺素",
                                "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001800",
                                "examName": "胰島素阻抗評估",
                                "examMemo": "",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000500",
                                "examName": "乳酸脫氫酶",
                                "examMemo": "乳酸脫氫酶是身體細胞損傷的指標，升高可能與組織受損、發炎或疾病有關",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014700A",
                                "examName": "頸動脈超音波",
                                "examMemo": "頸動脈超音波檢查可以評估頸部血管的狀況，發現動脈硬化或斑塊，幫助預防中風及心血管疾病的風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI006300",
                                "examName": "CYFRA 21-1腫瘤標記",
                                "examMemo": "CYFRA 21-1是肺部腫瘤參考指標，可作為肺癌追蹤監測與輔助診斷",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI001600",
                                "examName": "癌胚胎抗原",
                                "examMemo": "癌胚胎抗原（CEA）是血液中的腫瘤標記物，常用於篩檢評估大腸直腸癌及其他特定癌症的風險",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "L2004200A",
                                "examName": "EB病毒抗體IgA",
                                "examMemo": "EB病毒抗體IgA檢查評估是否感染EB病毒，常用於鼻咽癌高風險族群的初步篩檢",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "NC000109",
                                "examName": "(套檢)報告諮詢",
                                "examMemo": "專科醫師一對一報告諮詢",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000002",
                                "examName": "午餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [
                    {
                        "groupTitleName": "檢項 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "examItemList": [
                            {
                                "examItem": "R2053000",
                                "examName": "碳-13幽門桿菌呼氣試驗",
                                "examMemo": "碳-13幽門桿菌呼氣試驗能檢測胃中是否有幽門桿菌感染，這種細菌與胃炎和胃潰瘍有關，檢查結果可幫助診斷與治療胃病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "NC000002",
                                "examName": "(限內湖)營養諮詢",
                                "examMemo": "專業營養師一對一諮詢，針對個人身體狀況提供飲食衛教及建議",
                                "deptName": "營養素與礦物質",
                                "deptEName": "Nutrient & Mineral"
                            }
                        ]
                    }
                ],
                "groupChooseList": []
            },
            {
                "packageName": "中興工程公司(114-115年)無痛腸胃鏡(無健檢服)(男)24000(全)",
                "packageNo": "300410020",
                "price": "24000.00000",
                "dayType": "2",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": true,
                "deptList": [
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE000001A",
                                "examName": "眼底斷層掃描",
                                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "LB000201C",
                                "examName": "胃鏡",
                                "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L2001900",
                                "examName": "B型肝炎表面抗原",
                                "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "PE001000",
                                "examName": "麻醉(套檢)",
                                "examMemo": "若有BMI大於35以上、呼吸中止症、麻醉過敏或疑慮，請諮詢您的醫師並致電客服",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L2002000",
                                "examName": "B型肝炎表面抗體",
                                "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "LB000401P",
                                "examName": "(套檢A)NBI大腸鏡-含代餐包",
                                "examMemo": "利用NBI窄頻影像內視鏡系統及CO2充氣系統，進行全段大腸 乙狀結腸 直腸檢查，評估有無瘜肉 腫瘤 痔瘡等異常。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000500",
                                "examName": "乳酸脫氫酶",
                                "examMemo": "乳酸脫氫酶是身體細胞損傷的指標，升高可能與組織受損、發炎或疾病有關",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014700A",
                                "examName": "頸動脈超音波",
                                "examMemo": "頸動脈超音波檢查可以評估頸部血管的狀況，發現動脈硬化或斑塊，幫助預防中風及心血管疾病的風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R1010100A",
                                "examName": "胸部X光（正面）",
                                "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI006300",
                                "examName": "CYFRA 21-1腫瘤標記",
                                "examMemo": "CYFRA 21-1是肺部腫瘤參考指標，可作為肺癌追蹤監測與輔助診斷",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI001600",
                                "examName": "癌胚胎抗原",
                                "examMemo": "癌胚胎抗原（CEA）是血液中的腫瘤標記物，常用於篩檢評估大腸直腸癌及其他特定癌症的風險",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110051A",
                                "examName": "密閉式純音聽力檢查",
                                "examMemo": "密閉式純音聽力檢查可評估個人聽力狀況，幫助識別聽力損傷。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1040300A",
                                "examName": "頸椎X光",
                                "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "NC000109",
                                "examName": "(套檢)報告諮詢",
                                "examMemo": "專科醫師一對一報告諮詢",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000002",
                                "examName": "午餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [],
                "groupChooseList": []
            },
            {
                "packageName": "中興工程公司(114-115年)一般(男)5000(半)",
                "packageNo": "300410001",
                "price": "5000.00000",
                "dayType": "1",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": false,
                "deptList": [
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L4002800",
                                "examName": "潛血（酵素免疫）",
                                "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R1010100A",
                                "examName": "胸部X光（正面）",
                                "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110011B",
                                "examName": "聽力檢查",
                                "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [],
                "groupChooseList": [
                    {
                        "groupTitleName": "組合 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "groupList": [
                            {
                                "examItemList": [
                                    {
                                        "examItem": "R1040300A",
                                        "examName": "頸椎X光",
                                        "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
                                        "deptName": "肌肉骨骼系統",
                                        "deptEName": "Musculoskeletal System"
                                    },
                                    {
                                        "examItem": "R1020300A",
                                        "examName": "腹部X光及腰薦椎側面X光",
                                        "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                        "deptName": "肌肉骨骼系統",
                                        "deptEName": "Musculoskeletal System"
                                    }
                                ]
                            },
                            {
                                "examItemList": [
                                    {
                                        "examItem": "LI004500",
                                        "examName": "甲種胎兒蛋白",
                                        "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                        "deptName": "腫瘤標記",
                                        "deptEName": "Tumor Biomarker"
                                    },
                                    {
                                        "examItem": "LI001600",
                                        "examName": "癌胚胎抗原",
                                        "examMemo": "癌胚胎抗原（CEA）是血液中的腫瘤標記物，常用於篩檢評估大腸直腸癌及其他特定癌症的風險",
                                        "deptName": "腫瘤標記",
                                        "deptEName": "Tumor Biomarker"
                                    },
                                    {
                                        "examItem": "L2004200A",
                                        "examName": "EB病毒抗體IgA",
                                        "examMemo": "EB病毒抗體IgA檢查評估是否感染EB病毒，常用於鼻咽癌高風險族群的初步篩檢",
                                        "deptName": "腫瘤標記",
                                        "deptEName": "Tumor Biomarker"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "packageName": "中興工程公司(114-115年)電腦斷層(半日)(男)16000(半)",
                "packageNo": "300410018",
                "price": "16000.00000",
                "dayType": "1",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": false,
                "deptList": [
                    {
                        "deptName": "神經系統(Neurology)",
                        "deptEName": "Neuro",
                        "examItemList": [
                            {
                                "examItem": "L1008000A",
                                "examName": "HRV自律神經",
                                "examMemo": "HRV自律神經檢查能評估自主神經系統的平衡，反映壓力反應和健康狀態。",
                                "deptName": "神經系統",
                                "deptEName": "Neurology"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L4002800",
                                "examName": "潛血（酵素免疫）",
                                "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L6000800",
                                "examName": "胰澱粉酶",
                                "examMemo": "胰澱粉脢是消化酶，主要分解澱粉為葡萄糖。檢查其活性可評估胰腺功能，幫助診斷胰臟炎或其他消化問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R1010100A",
                                "examName": "胸部X光（正面）",
                                "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "男性醫學(Male medicine)",
                        "deptEName": "Male",
                        "examItemList": [
                            {
                                "examItem": "LI001400",
                                "examName": "睪固酮",
                                "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                                "deptName": "男性醫學",
                                "deptEName": "Male medicine"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110011B",
                                "examName": "聽力檢查",
                                "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R2026000A",
                                "examName": "甲狀腺超音波",
                                "examMemo": "透過影像檢查甲狀腺的大小、形狀以及是否有結節或其他異常變化。常搭配血液檢驗（如TSH、T3、T4）一同評估甲狀腺健康狀況。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI006900A",
                                "examName": "游離前列腺特異抗原",
                                "examMemo": "攝護腺病變篩檢參考指標",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI001600",
                                "examName": "癌胚胎抗原",
                                "examMemo": "癌胚胎抗原（CEA）是血液中的腫瘤標記物，常用於篩檢評估大腸直腸癌及其他特定癌症的風險",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "F00000020",
                                "examName": "影像接駁交通費",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [
                    {
                        "groupTitleName": "檢項 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "examItemList": [
                            {
                                "examItem": "R9003800A",
                                "examName": "(套檢)冠狀動脈鈣化積分",
                                "examMemo": "檢查心臟冠狀動脈鈣化程度，評估心肌梗塞風險（若有裝置心臟支架、心律調節器、人工心臟瓣膜或胸椎打釘，無法排檢）",
                                "deptName": "影像醫學",
                                "deptEName": "CT/MRI"
                            },
                            {
                                "examItem": "R9003900A",
                                "examName": "(套檢)低劑量肺部電腦斷層",
                                "examMemo": "篩檢早期肺癌最佳利器！能精確檢查肺部有無腫瘤、肺炎、肉芽腫或纖維化等異常",
                                "deptName": "影像醫學",
                                "deptEName": "CT/MRI"
                            }
                        ]
                    }
                ],
                "groupChooseList": []
            },
            {
                "packageName": "中興工程公司(114-115年)無痛胃鏡或無痛大腸鏡(半日)(男)16000(半)",
                "packageNo": "300410014",
                "price": "16000.00000",
                "dayType": "1",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": false,
                "deptList": [
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE000001A",
                                "examName": "眼底斷層掃描",
                                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "PE001000",
                                "examName": "麻醉(套檢)",
                                "examMemo": "若有BMI大於35以上、呼吸中止症、麻醉過敏或疑慮，請諮詢您的醫師並致電客服",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R132001DA",
                                "examName": "胸部X光（正面及左側面）",
                                "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI006900A",
                                "examName": "游離前列腺特異抗原",
                                "examMemo": "攝護腺病變篩檢參考指標",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110011B",
                                "examName": "聽力檢查",
                                "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1040300A",
                                "examName": "頸椎X光",
                                "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [],
                "groupChooseList": [
                    {
                        "groupTitleName": "組合 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "groupList": [
                            {
                                "examItemList": [
                                    {
                                        "examItem": "LB000401P",
                                        "examName": "(套檢A)NBI大腸鏡-含代餐包",
                                        "examMemo": "利用NBI窄頻影像內視鏡系統及CO2充氣系統，進行全段大腸 乙狀結腸 直腸檢查，評估有無瘜肉 腫瘤 痔瘡等異常。",
                                        "deptName": "消化系統",
                                        "deptEName": "Digestive System"
                                    }
                                ]
                            },
                            {
                                "examItemList": [
                                    {
                                        "examItem": "LB000201C",
                                        "examName": "胃鏡",
                                        "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
                                        "deptName": "消化系統",
                                        "deptEName": "Digestive System"
                                    },
                                    {
                                        "examItem": "L4002800",
                                        "examName": "潛血（酵素免疫）",
                                        "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                        "deptName": "消化系統",
                                        "deptEName": "Digestive System"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "packageName": "中興工程公司(114-115年)肺CT/鈣化(無上腹超)(男)12000(半)",
                "packageNo": "300410012",
                "price": "12000.00000",
                "dayType": "1",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": false,
                "deptList": [
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L4002800",
                                "examName": "潛血（酵素免疫）",
                                "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R1010100A",
                                "examName": "胸部X光（正面）",
                                "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110011B",
                                "examName": "聽力檢查",
                                "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "F00000020",
                                "examName": "影像接駁交通費",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [
                    {
                        "groupTitleName": "檢項 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "examItemList": [
                            {
                                "examItem": "R9003800A",
                                "examName": "(套檢)冠狀動脈鈣化積分",
                                "examMemo": "檢查心臟冠狀動脈鈣化程度，評估心肌梗塞風險（若有裝置心臟支架、心律調節器、人工心臟瓣膜或胸椎打釘，無法排檢）",
                                "deptName": "影像醫學",
                                "deptEName": "CT/MRI"
                            },
                            {
                                "examItem": "R9003900A",
                                "examName": "(套檢)低劑量肺部電腦斷層",
                                "examMemo": "篩檢早期肺癌最佳利器！能精確檢查肺部有無腫瘤、肺炎、肉芽腫或纖維化等異常",
                                "deptName": "影像醫學",
                                "deptEName": "CT/MRI"
                            }
                        ]
                    }
                ],
                "groupChooseList": []
            },
            {
                "packageName": "中興工程公司(114-115年)心血管(男)12000(半)",
                "packageNo": "300410010",
                "price": "12000.00000",
                "dayType": "1",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": false,
                "deptList": [
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L4002800",
                                "examName": "潛血（酵素免疫）",
                                "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R132001DA",
                                "examName": "胸部X光（正面及左側面）",
                                "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "男性醫學(Male medicine)",
                        "deptEName": "Male",
                        "examItemList": [
                            {
                                "examItem": "LI001400",
                                "examName": "睪固酮",
                                "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                                "deptName": "男性醫學",
                                "deptEName": "Male medicine"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110011B",
                                "examName": "聽力檢查",
                                "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "營養素與礦物質(Nutrient & Mineral )",
                        "deptEName": "NUT",
                        "examItemList": [
                            {
                                "examItem": "VIT0002",
                                "examName": "維他命 D",
                                "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
                                "deptName": "營養素與礦物質",
                                "deptEName": "Nutrient & Mineral"
                            },
                            {
                                "examItem": "VIT0005",
                                "examName": "維生素 B12",
                                "examMemo": "維他命B12檢查能評估血液中B12濃度，低可能導致貧血、神經問題及認知障礙，早期發現有助於預防這些健康問題。",
                                "deptName": "營養素與礦物質",
                                "deptEName": "Nutrient & Mineral"
                            }
                        ]
                    },
                    {
                        "deptName": "風濕免疫系統(Rheumatology and Immunology )",
                        "deptEName": "Rheuma",
                        "examItemList": [
                            {
                                "examItem": "L2000600",
                                "examName": "類風濕性關節炎因子",
                                "examMemo": "類風濕性關節炎因子（RF）是檢測類風濕性關節炎的指標，高可能表示免疫系統異常，導致關節炎症。檢查RF有助於早期診斷與治療。",
                                "deptName": "風濕免疫系統",
                                "deptEName": "Rheumatology and Immunology"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE000001A",
                                "examName": "眼底斷層掃描",
                                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4011700A",
                                "examName": "心臟超音波",
                                "examMemo": "心臟超音波能無痛檢查心臟結構與功能，評估心臟疾病風險、瓣膜狀況及血流，幫助早期發現問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L6001500",
                                "examName": "肌酸磷化酶同功酶MB型",
                                "examMemo": "肌酸磷化酶-MB同功酶（CK-MB）是心肌損傷的指標。檢查CK-MB有助於早期診斷心臟疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI007500",
                                "examName": "前腦排鈉利尿胜肽",
                                "examMemo": "前腦排鈉利尿胜肽（BNP）是心臟細胞釋出的激素，當心臟功能變弱或有衰竭傾向時，BNP 會上升，因此是評估心臟衰竭的重要指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018300",
                                "examName": "同半胱胺酸",
                                "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "FM000021",
                                "examName": "脂蛋白(a)",
                                "examMemo": "脂蛋白(a)結構類似LDL（壞膽固醇），過高會顯著增加心肌梗塞、中風、血管狹窄的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000600",
                                "examName": "皮質素(08:30AM前報到)",
                                "examMemo": "皮質素是評估腎上腺功能的重要指標，與身體應對壓力，調節血糖、血壓及免疫系統有關",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014700A",
                                "examName": "頸動脈超音波",
                                "examMemo": "頸動脈超音波檢查可以評估頸部血管的狀況，發現動脈硬化或斑塊，幫助預防中風及心血管疾病的風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI006900A",
                                "examName": "游離前列腺特異抗原",
                                "examMemo": "攝護腺病變篩檢參考指標",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI001600",
                                "examName": "癌胚胎抗原",
                                "examMemo": "癌胚胎抗原（CEA）是血液中的腫瘤標記物，常用於篩檢評估大腸直腸癌及其他特定癌症的風險",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "L2004200A",
                                "examName": "EB病毒抗體IgA",
                                "examMemo": "EB病毒抗體IgA檢查評估是否感染EB病毒，常用於鼻咽癌高風險族群的初步篩檢",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [],
                "groupChooseList": []
            },
            {
                "packageName": "中興工程公司(114-115年)無痛胃鏡或有感大腸鏡(男)12000(半)",
                "packageNo": "300410008",
                "price": "12000.00000",
                "dayType": "1",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": false,
                "deptList": [
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R1010100A",
                                "examName": "胸部X光（正面）",
                                "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI006900A",
                                "examName": "游離前列腺特異抗原",
                                "examMemo": "攝護腺病變篩檢參考指標",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110011B",
                                "examName": "聽力檢查",
                                "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [],
                "groupChooseList": [
                    {
                        "groupTitleName": "組合 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "groupList": [
                            {
                                "examItemList": [
                                    {
                                        "examItem": "LB000401P",
                                        "examName": "(套檢A)NBI大腸鏡-含代餐包",
                                        "examMemo": "利用NBI窄頻影像內視鏡系統及CO2充氣系統，進行全段大腸 乙狀結腸 直腸檢查，評估有無瘜肉 腫瘤 痔瘡等異常。",
                                        "deptName": "消化系統",
                                        "deptEName": "Digestive System"
                                    }
                                ]
                            },
                            {
                                "examItemList": [
                                    {
                                        "examItem": "LB000201C",
                                        "examName": "胃鏡",
                                        "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
                                        "deptName": "消化系統",
                                        "deptEName": "Digestive System"
                                    },
                                    {
                                        "examItem": "PE001000",
                                        "examName": "麻醉(套檢)",
                                        "examMemo": "若有BMI大於35以上、呼吸中止症、麻醉過敏或疑慮，請諮詢您的醫師並致電客服",
                                        "deptName": "消化系統",
                                        "deptEName": "Digestive System"
                                    },
                                    {
                                        "examItem": "L4002800",
                                        "examName": "潛血（酵素免疫）",
                                        "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                        "deptName": "消化系統",
                                        "deptEName": "Digestive System"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "packageName": "中興工程公司(114-115年)精選(男)10000(半)",
                "packageNo": "300410005",
                "price": "10000.00000",
                "dayType": "1",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": false,
                "deptList": [
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L4002800",
                                "examName": "潛血（酵素免疫）",
                                "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L6002100",
                                "examName": "脂酶",
                                "examMemo": "脂脢是幫助分解脂肪的消化酵素，主要由胰臟製造。檢查脂脢濃度可評估胰臟炎或其他消化系統問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L6000800",
                                "examName": "胰澱粉酶",
                                "examMemo": "胰澱粉脢是消化酶，主要分解澱粉為葡萄糖。檢查其活性可評估胰腺功能，幫助診斷胰臟炎或其他消化問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R132001DA",
                                "examName": "胸部X光（正面及左側面）",
                                "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "男性醫學(Male medicine)",
                        "deptEName": "Male",
                        "examItemList": [
                            {
                                "examItem": "LI001400",
                                "examName": "睪固酮",
                                "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                                "deptName": "男性醫學",
                                "deptEName": "Male medicine"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110011B",
                                "examName": "聽力檢查",
                                "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1040300A",
                                "examName": "頸椎X光",
                                "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3002100A",
                                "examName": "電解質",
                                "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE000001A",
                                "examName": "眼底斷層掃描",
                                "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI001700A",
                                "examName": "飯前胰島素(含阻抗)",
                                "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI006900A",
                                "examName": "游離前列腺特異抗原",
                                "examMemo": "攝護腺病變篩檢參考指標",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI001600",
                                "examName": "癌胚胎抗原",
                                "examMemo": "癌胚胎抗原（CEA）是血液中的腫瘤標記物，常用於篩檢評估大腸直腸癌及其他特定癌症的風險",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [
                    {
                        "groupTitleName": "檢項 3 選 1",
                        "groupCount": 3,
                        "chooseCount": 1,
                        "examItemList": [
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "L3004600",
                                "examName": "骨鈣素",
                                "examMemo": "骨鈣素可評估骨質新生速度，有助了解骨骼健康與骨質疏鬆風險",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "VIT0002",
                                "examName": "維他命 D",
                                "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
                                "deptName": "營養素與礦物質",
                                "deptEName": "Nutrient & Mineral"
                            }
                        ]
                    }
                ],
                "groupChooseList": [
                    {
                        "groupTitleName": "組合 2 選 1",
                        "groupCount": 2,
                        "chooseCount": 1,
                        "groupList": [
                            {
                                "examItemList": [
                                    {
                                        "examItem": "R2026000A",
                                        "examName": "甲狀腺超音波",
                                        "examMemo": "透過影像檢查甲狀腺的大小、形狀以及是否有結節或其他異常變化。常搭配血液檢驗（如TSH、T3、T4）一同評估甲狀腺健康狀況。",
                                        "deptName": "心血管及代謝系統",
                                        "deptEName": "Cardiovascular and Metabolic System"
                                    },
                                    {
                                        "examItem": "R4014700A",
                                        "examName": "頸動脈超音波",
                                        "examMemo": "頸動脈超音波檢查可以評估頸部血管的狀況，發現動脈硬化或斑塊，幫助預防中風及心血管疾病的風險。",
                                        "deptName": "心血管及代謝系統",
                                        "deptEName": "Cardiovascular and Metabolic System"
                                    },
                                    {
                                        "examItem": "L2004200A",
                                        "examName": "EB病毒抗體IgA",
                                        "examMemo": "EB病毒抗體IgA檢查評估是否感染EB病毒，常用於鼻咽癌高風險族群的初步篩檢",
                                        "deptName": "腫瘤標記",
                                        "deptEName": "Tumor Biomarker"
                                    }
                                ]
                            },
                            {
                                "examItemList": [
                                    {
                                        "examItem": "R4011700A",
                                        "examName": "心臟超音波",
                                        "examMemo": "心臟超音波能無痛檢查心臟結構與功能，評估心臟疾病風險、瓣膜狀況及血流，幫助早期發現問題。",
                                        "deptName": "心血管及代謝系統",
                                        "deptEName": "Cardiovascular and Metabolic System"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "packageName": "中興工程公司(114-115年)有感胃鏡(男)10000(半)",
                "packageNo": "300410003",
                "price": "10000.00000",
                "dayType": "1",
                "bookPeriod": "1",
                "hasBreakfast": true,
                "hasLunch": false,
                "deptList": [
                    {
                        "deptName": "神經系統(Neurology)",
                        "deptEName": "Neuro",
                        "examItemList": [
                            {
                                "examItem": "L1008000A",
                                "examName": "HRV自律神經",
                                "examMemo": "HRV自律神經檢查能評估自主神經系統的平衡，反映壓力反應和健康狀態。",
                                "deptName": "神經系統",
                                "deptEName": "Neurology"
                            }
                        ]
                    },
                    {
                        "deptName": "消化系統(Digestive System)",
                        "deptEName": "GI",
                        "examItemList": [
                            {
                                "examItem": "LB000201C",
                                "examName": "胃鏡",
                                "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000200",
                                "examName": "麩胺酸苯醋酸轉氨基酶",
                                "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000400",
                                "examName": "麩胺酸轉肽酶",
                                "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001700",
                                "examName": "總膽紅素",
                                "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001800",
                                "examName": "總蛋白",
                                "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3018100",
                                "examName": "白蛋白",
                                "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L4002800",
                                "examName": "潛血（酵素免疫）",
                                "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "R2022000A",
                                "examName": "上腹部超音波",
                                "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000100",
                                "examName": "鹼性磷酸酶",
                                "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3001710",
                                "examName": "直接膽紅素",
                                "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L6000800",
                                "examName": "胰澱粉酶",
                                "examMemo": "胰澱粉脢是消化酶，主要分解澱粉為葡萄糖。檢查其活性可評估胰腺功能，幫助診斷胰臟炎或其他消化問題。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L3000300",
                                "examName": "麩胺酸丙酮酸轉氨基酶",
                                "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            },
                            {
                                "examItem": "L301810003",
                                "examName": "球蛋白",
                                "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                                "deptName": "消化系統",
                                "deptEName": "Digestive System"
                            }
                        ]
                    },
                    {
                        "deptName": "肺部檢查(Lung Examination)",
                        "deptEName": "Lung",
                        "examItemList": [
                            {
                                "examItem": "R132001DA",
                                "examName": "胸部X光（正面及左側面）",
                                "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                                "deptName": "肺部檢查",
                                "deptEName": "Lung Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "耳鼻喉科檢查(ENT Examination)",
                        "deptEName": "ENT",
                        "examItemList": [
                            {
                                "examItem": "T700110011B",
                                "examName": "聽力檢查",
                                "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                                "deptName": "耳鼻喉科檢查",
                                "deptEName": "ENT Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "肌肉骨骼系統(Musculoskeletal System)",
                        "deptEName": "Skeletal",
                        "examItemList": [
                            {
                                "examItem": "R1020300A",
                                "examName": "腹部X光及腰薦椎側面X光",
                                "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            },
                            {
                                "examItem": "R1140400A",
                                "examName": "左髖關節骨質密度",
                                "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                                "deptName": "肌肉骨骼系統",
                                "deptEName": "Musculoskeletal System"
                            }
                        ]
                    },
                    {
                        "deptName": "腎臟泌尿系統(Kidney and Urology)",
                        "deptEName": "Kidney",
                        "examItemList": [
                            {
                                "examItem": "L3001500",
                                "examName": "肌酸酐",
                                "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001300",
                                "examName": "尿素氮",
                                "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L300150001",
                                "examName": "腎絲球過濾率",
                                "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L4002000A",
                                "examName": "尿液常規檢查",
                                "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            },
                            {
                                "examItem": "L3001400",
                                "examName": "尿酸",
                                "examMemo": "尿酸檢查可評估痛風及腎功能。",
                                "deptName": "腎臟泌尿系統",
                                "deptEName": "Kidney and Urology"
                            }
                        ]
                    },
                    {
                        "deptName": "眼科檢查(Eye Examination)",
                        "deptEName": "Eye",
                        "examItemList": [
                            {
                                "examItem": "PE00040001B",
                                "examName": "視力",
                                "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040014",
                                "examName": "石原色覺檢查表",
                                "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            },
                            {
                                "examItem": "PE00040004B",
                                "examName": "眼壓",
                                "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                                "deptName": "眼科檢查",
                                "deptEName": "Eye Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "理學檢查(Physical  Examination)",
                        "deptEName": "Physical",
                        "examItemList": [
                            {
                                "examItem": "HI000001A",
                                "examName": "個人主訴",
                                "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            },
                            {
                                "examItem": "PE00010023A",
                                "examName": "理學檢查",
                                "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                                "deptName": "理學檢查",
                                "deptEName": "Physical  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "血液系統(Hematology)",
                        "deptEName": "Hema",
                        "examItemList": [
                            {
                                "examItem": "L5000500",
                                "examName": "白血球分類",
                                "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            },
                            {
                                "examItem": "L5003200",
                                "examName": "血球計數",
                                "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                                "deptName": "血液系統",
                                "deptEName": "Hematology"
                            }
                        ]
                    },
                    {
                        "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                        "deptEName": "Cardio",
                        "examItemList": [
                            {
                                "examItem": "L300350002",
                                "examName": "低/高密度脂蛋白比值",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000800",
                                "examName": "飯前血糖",
                                "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3005200",
                                "examName": "低密度脂蛋白-膽固醇",
                                "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R4014710A",
                                "examName": "周邊動脈硬化評估",
                                "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L300350001",
                                "examName": "總/高密度膽固醇比",
                                "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3018400",
                                "examName": "高敏感性C反應蛋白",
                                "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L1001100A",
                                "examName": "靜式心電圖",
                                "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "R401470005",
                                "examName": "十年心血管疾病風險評估",
                                "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3002000",
                                "examName": "三酸甘油酯",
                                "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3001900",
                                "examName": "總膽固醇",
                                "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3003500",
                                "examName": "高密度脂蛋白-膽固醇",
                                "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "L3000700",
                                "examName": "糖化血色素",
                                "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            },
                            {
                                "examItem": "LI000400",
                                "examName": "甲狀腺刺激素",
                                "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                                "deptName": "心血管及代謝系統",
                                "deptEName": "Cardiovascular and Metabolic System"
                            }
                        ]
                    },
                    {
                        "deptName": "腫瘤標記(Tumor Biomarker)",
                        "deptEName": "Tumor",
                        "examItemList": [
                            {
                                "examItem": "LI004100",
                                "examName": "CA199腫瘤標記",
                                "examMemo": "CA199是胰臟及膽道腫瘤的參考標記，可輔助診斷相關腫瘤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004500",
                                "examName": "甲種胎兒蛋白",
                                "examMemo": "甲種胎兒蛋白（AFP）是評估肝臟健康及某些腫瘤的參考指標，常用於肝癌篩檢與追蹤。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI001600",
                                "examName": "癌胚胎抗原",
                                "examMemo": "癌胚胎抗原（CEA）是血液中的腫瘤標記物，常用於篩檢評估大腸直腸癌及其他特定癌症的風險",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            },
                            {
                                "examItem": "LI004600",
                                "examName": "前列腺特異抗原",
                                "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                                "deptName": "腫瘤標記",
                                "deptEName": "Tumor Biomarker"
                            }
                        ]
                    },
                    {
                        "deptName": "一般檢查(General  Examination)",
                        "deptEName": "General",
                        "examItemList": [
                            {
                                "examItem": "PE00010001",
                                "examName": "身高",
                                "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010019",
                                "examName": "體脂肪率",
                                "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010002",
                                "examName": "體重",
                                "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010003",
                                "examName": "理想體重",
                                "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010006",
                                "examName": "身體質量指數",
                                "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010017",
                                "examName": "腰圍",
                                "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010040",
                                "examName": "身體組成分析",
                                "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010007A",
                                "examName": "脈搏",
                                "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            },
                            {
                                "examItem": "PE00010009A",
                                "examName": "血壓",
                                "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                                "deptName": "一般檢查",
                                "deptEName": "General  Examination"
                            }
                        ]
                    },
                    {
                        "deptName": "其他(Other)",
                        "deptEName": "Other",
                        "examItemList": [
                            {
                                "examItem": "H0000074",
                                "examName": "(套檢)健康管理服務平台B2B",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "PE00010038",
                                "examName": "健康調查表",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            },
                            {
                                "examItem": "F0000022",
                                "examName": "早餐",
                                "examMemo": "",
                                "deptName": "其他",
                                "deptEName": "Other"
                            }
                        ]
                    }
                ],
                "examChooseList": [],
                "groupChooseList": []
            }
        ]
    },
    "businessSelectedPackage": {
        "packageName": "中興工程公司(114-115年)一般(男)5000(半)",
        "packageNo": "300410001",
        "price": "5000.00000",
        "dayType": "1",
        "bookPeriod": "1",
        "hasBreakfast": true,
        "hasLunch": false,
        "deptList": [
            {
                "deptName": "眼科檢查(Eye Examination)",
                "deptEName": "Eye",
                "examItemList": [
                    {
                        "examItem": "PE00040001B",
                        "examName": "視力",
                        "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                        "deptName": "眼科檢查",
                        "deptEName": "Eye Examination"
                    },
                    {
                        "examItem": "PE00040014",
                        "examName": "石原色覺檢查表",
                        "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                        "deptName": "眼科檢查",
                        "deptEName": "Eye Examination"
                    },
                    {
                        "examItem": "PE00040004B",
                        "examName": "眼壓",
                        "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                        "deptName": "眼科檢查",
                        "deptEName": "Eye Examination"
                    }
                ]
            },
            {
                "deptName": "理學檢查(Physical  Examination)",
                "deptEName": "Physical",
                "examItemList": [
                    {
                        "examItem": "HI000001A",
                        "examName": "個人主訴",
                        "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                        "deptName": "理學檢查",
                        "deptEName": "Physical  Examination"
                    },
                    {
                        "examItem": "PE00010023A",
                        "examName": "理學檢查",
                        "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                        "deptName": "理學檢查",
                        "deptEName": "Physical  Examination"
                    }
                ]
            },
            {
                "deptName": "消化系統(Digestive System)",
                "deptEName": "GI",
                "examItemList": [
                    {
                        "examItem": "L3000200",
                        "examName": "麩胺酸苯醋酸轉氨基酶",
                        "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "L3000400",
                        "examName": "麩胺酸轉肽酶",
                        "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "L3001700",
                        "examName": "總膽紅素",
                        "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "L3001800",
                        "examName": "總蛋白",
                        "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "L3018100",
                        "examName": "白蛋白",
                        "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "L4002800",
                        "examName": "潛血（酵素免疫）",
                        "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "R2022000A",
                        "examName": "上腹部超音波",
                        "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "L3000100",
                        "examName": "鹼性磷酸酶",
                        "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "L3001710",
                        "examName": "直接膽紅素",
                        "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "L3000300",
                        "examName": "麩胺酸丙酮酸轉氨基酶",
                        "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    },
                    {
                        "examItem": "L301810003",
                        "examName": "球蛋白",
                        "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                        "deptName": "消化系統",
                        "deptEName": "Digestive System"
                    }
                ]
            },
            {
                "deptName": "血液系統(Hematology)",
                "deptEName": "Hema",
                "examItemList": [
                    {
                        "examItem": "L5000500",
                        "examName": "白血球分類",
                        "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                        "deptName": "血液系統",
                        "deptEName": "Hematology"
                    },
                    {
                        "examItem": "L5003200",
                        "examName": "血球計數",
                        "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                        "deptName": "血液系統",
                        "deptEName": "Hematology"
                    }
                ]
            },
            {
                "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
                "deptEName": "Cardio",
                "examItemList": [
                    {
                        "examItem": "L300350002",
                        "examName": "低/高密度脂蛋白比值",
                        "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    },
                    {
                        "examItem": "L3000800",
                        "examName": "飯前血糖",
                        "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    },
                    {
                        "examItem": "L3005200",
                        "examName": "低密度脂蛋白-膽固醇",
                        "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    },
                    {
                        "examItem": "L300350001",
                        "examName": "總/高密度膽固醇比",
                        "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    },
                    {
                        "examItem": "L1001100A",
                        "examName": "靜式心電圖",
                        "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    },
                    {
                        "examItem": "R401470005",
                        "examName": "十年心血管疾病風險評估",
                        "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    },
                    {
                        "examItem": "L3002000",
                        "examName": "三酸甘油酯",
                        "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    },
                    {
                        "examItem": "L3001900",
                        "examName": "總膽固醇",
                        "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    },
                    {
                        "examItem": "L3003500",
                        "examName": "高密度脂蛋白-膽固醇",
                        "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    },
                    {
                        "examItem": "L3000700",
                        "examName": "糖化血色素",
                        "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                        "deptName": "心血管及代謝系統",
                        "deptEName": "Cardiovascular and Metabolic System"
                    }
                ]
            },
            {
                "deptName": "肺部檢查(Lung Examination)",
                "deptEName": "Lung",
                "examItemList": [
                    {
                        "examItem": "R1010100A",
                        "examName": "胸部X光（正面）",
                        "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
                        "deptName": "肺部檢查",
                        "deptEName": "Lung Examination"
                    }
                ]
            },
            {
                "deptName": "腫瘤標記(Tumor Biomarker)",
                "deptEName": "Tumor",
                "examItemList": [
                    {
                        "examItem": "LI004600",
                        "examName": "前列腺特異抗原",
                        "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
                        "deptName": "腫瘤標記",
                        "deptEName": "Tumor Biomarker"
                    }
                ]
            },
            {
                "deptName": "一般檢查(General  Examination)",
                "deptEName": "General",
                "examItemList": [
                    {
                        "examItem": "PE00010001",
                        "examName": "身高",
                        "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                        "deptName": "一般檢查",
                        "deptEName": "General  Examination"
                    },
                    {
                        "examItem": "PE00010019",
                        "examName": "體脂肪率",
                        "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                        "deptName": "一般檢查",
                        "deptEName": "General  Examination"
                    },
                    {
                        "examItem": "PE00010002",
                        "examName": "體重",
                        "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                        "deptName": "一般檢查",
                        "deptEName": "General  Examination"
                    },
                    {
                        "examItem": "PE00010003",
                        "examName": "理想體重",
                        "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                        "deptName": "一般檢查",
                        "deptEName": "General  Examination"
                    },
                    {
                        "examItem": "PE00010006",
                        "examName": "身體質量指數",
                        "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                        "deptName": "一般檢查",
                        "deptEName": "General  Examination"
                    },
                    {
                        "examItem": "PE00010017",
                        "examName": "腰圍",
                        "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                        "deptName": "一般檢查",
                        "deptEName": "General  Examination"
                    },
                    {
                        "examItem": "PE00010040",
                        "examName": "身體組成分析",
                        "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                        "deptName": "一般檢查",
                        "deptEName": "General  Examination"
                    },
                    {
                        "examItem": "PE00010007A",
                        "examName": "脈搏",
                        "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                        "deptName": "一般檢查",
                        "deptEName": "General  Examination"
                    },
                    {
                        "examItem": "PE00010009A",
                        "examName": "血壓",
                        "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                        "deptName": "一般檢查",
                        "deptEName": "General  Examination"
                    }
                ]
            },
            {
                "deptName": "耳鼻喉科檢查(ENT Examination)",
                "deptEName": "ENT",
                "examItemList": [
                    {
                        "examItem": "T700110011B",
                        "examName": "聽力檢查",
                        "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                        "deptName": "耳鼻喉科檢查",
                        "deptEName": "ENT Examination"
                    }
                ]
            },
            {
                "deptName": "腎臟泌尿系統(Kidney and Urology)",
                "deptEName": "Kidney",
                "examItemList": [
                    {
                        "examItem": "L3001500",
                        "examName": "肌酸酐",
                        "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                        "deptName": "腎臟泌尿系統",
                        "deptEName": "Kidney and Urology"
                    },
                    {
                        "examItem": "L3001300",
                        "examName": "尿素氮",
                        "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                        "deptName": "腎臟泌尿系統",
                        "deptEName": "Kidney and Urology"
                    },
                    {
                        "examItem": "L300150001",
                        "examName": "腎絲球過濾率",
                        "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                        "deptName": "腎臟泌尿系統",
                        "deptEName": "Kidney and Urology"
                    },
                    {
                        "examItem": "L4002000A",
                        "examName": "尿液常規檢查",
                        "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                        "deptName": "腎臟泌尿系統",
                        "deptEName": "Kidney and Urology"
                    },
                    {
                        "examItem": "L3001400",
                        "examName": "尿酸",
                        "examMemo": "尿酸檢查可評估痛風及腎功能。",
                        "deptName": "腎臟泌尿系統",
                        "deptEName": "Kidney and Urology"
                    }
                ]
            },
            {
                "deptName": "其他(Other)",
                "deptEName": "Other",
                "examItemList": [
                    {
                        "examItem": "H0000074",
                        "examName": "(套檢)健康管理服務平台B2B",
                        "examMemo": "",
                        "deptName": "其他",
                        "deptEName": "Other"
                    },
                    {
                        "examItem": "PE00010038",
                        "examName": "健康調查表",
                        "examMemo": "",
                        "deptName": "其他",
                        "deptEName": "Other"
                    },
                    {
                        "examItem": "F0000022",
                        "examName": "早餐",
                        "examMemo": "",
                        "deptName": "其他",
                        "deptEName": "Other"
                    }
                ]
            }
        ],
        "examChooseList": [],
        "groupChooseList": [
            {
                "groupTitleName": "組合 2 選 1",
                "groupCount": 2,
                "chooseCount": 1,
                "groupList": []
            }
        ]
    },
    "examItemList": [
        {
            "deptName": "眼科檢查(Eye Examination)",
            "examName": "視力",
            "examItem": "PE00040001B",
            "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "眼科檢查(Eye Examination)",
            "examName": "石原色覺檢查表",
            "examItem": "PE00040014",
            "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "眼科檢查(Eye Examination)",
            "examName": "眼壓",
            "examItem": "PE00040004B",
            "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "理學檢查(Physical  Examination)",
            "examName": "個人主訴",
            "examItem": "HI000001A",
            "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "理學檢查(Physical  Examination)",
            "examName": "理學檢查",
            "examItem": "PE00010023A",
            "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "麩胺酸苯醋酸轉氨基酶",
            "examItem": "L3000200",
            "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "麩胺酸轉肽酶",
            "examItem": "L3000400",
            "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "總膽紅素",
            "examItem": "L3001700",
            "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "總蛋白",
            "examItem": "L3001800",
            "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "白蛋白",
            "examItem": "L3018100",
            "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "潛血（酵素免疫）",
            "examItem": "L4002800",
            "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "上腹部超音波",
            "examItem": "R2022000A",
            "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "鹼性磷酸酶",
            "examItem": "L3000100",
            "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "直接膽紅素",
            "examItem": "L3001710",
            "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "麩胺酸丙酮酸轉氨基酶",
            "examItem": "L3000300",
            "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "球蛋白",
            "examItem": "L301810003",
            "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "血液系統(Hematology)",
            "examName": "白血球分類",
            "examItem": "L5000500",
            "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "血液系統(Hematology)",
            "examName": "血球計數",
            "examItem": "L5003200",
            "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "低/高密度脂蛋白比值",
            "examItem": "L300350002",
            "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "飯前血糖",
            "examItem": "L3000800",
            "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "低密度脂蛋白-膽固醇",
            "examItem": "L3005200",
            "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "總/高密度膽固醇比",
            "examItem": "L300350001",
            "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "靜式心電圖",
            "examItem": "L1001100A",
            "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "十年心血管疾病風險評估",
            "examItem": "R401470005",
            "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "三酸甘油酯",
            "examItem": "L3002000",
            "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "總膽固醇",
            "examItem": "L3001900",
            "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "高密度脂蛋白-膽固醇",
            "examItem": "L3003500",
            "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "糖化血色素",
            "examItem": "L3000700",
            "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "肺部檢查(Lung Examination)",
            "examName": "胸部X光（正面）",
            "examItem": "R1010100A",
            "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腫瘤標記(Tumor Biomarker)",
            "examName": "前列腺特異抗原",
            "examItem": "LI004600",
            "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "身高",
            "examItem": "PE00010001",
            "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "體脂肪率",
            "examItem": "PE00010019",
            "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "體重",
            "examItem": "PE00010002",
            "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "理想體重",
            "examItem": "PE00010003",
            "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "身體質量指數",
            "examItem": "PE00010006",
            "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "腰圍",
            "examItem": "PE00010017",
            "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "身體組成分析",
            "examItem": "PE00010040",
            "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "脈搏",
            "examItem": "PE00010007A",
            "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "血壓",
            "examItem": "PE00010009A",
            "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "耳鼻喉科檢查(ENT Examination)",
            "examName": "聽力檢查",
            "examItem": "T700110011B",
            "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "肌酸酐",
            "examItem": "L3001500",
            "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "尿素氮",
            "examItem": "L3001300",
            "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "腎絲球過濾率",
            "examItem": "L300150001",
            "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "尿液常規檢查",
            "examItem": "L4002000A",
            "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "尿酸",
            "examItem": "L3001400",
            "examMemo": "尿酸檢查可評估痛風及腎功能。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "其他(Other)",
            "examName": "(套檢)健康管理服務平台B2B",
            "examItem": "H0000074",
            "examMemo": "",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "其他(Other)",
            "examName": "健康調查表",
            "examItem": "PE00010038",
            "examMemo": "",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "其他(Other)",
            "examName": "早餐",
            "examItem": "F0000022",
            "examMemo": "",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "組合",
            "deptEName": "Musculoskeletal System",
            "examName": "頸椎X光",
            "examItem": "R1040300A",
            "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "組合",
            "deptEName": "Musculoskeletal System",
            "examName": "腹部X光及腰薦椎側面X光",
            "examItem": "R1020300A",
            "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
            "examPrice": "0",
            "selectFlag": 1
        }
    ],
    "packagePrice": "5000.00000",
    "mutexItems": {},
    "paymentAmount": 1,
    "addExamItemList": [],
    "removeItemQuestionMap": [],
    "originalExamItemList": [
        {
            "deptName": "眼科檢查(Eye Examination)",
            "examName": "視力",
            "examItem": "PE00040001B",
            "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "眼科檢查(Eye Examination)",
            "examName": "石原色覺檢查表",
            "examItem": "PE00040014",
            "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "眼科檢查(Eye Examination)",
            "examName": "眼壓",
            "examItem": "PE00040004B",
            "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "理學檢查(Physical  Examination)",
            "examName": "個人主訴",
            "examItem": "HI000001A",
            "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "理學檢查(Physical  Examination)",
            "examName": "理學檢查",
            "examItem": "PE00010023A",
            "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "麩胺酸苯醋酸轉氨基酶",
            "examItem": "L3000200",
            "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "麩胺酸轉肽酶",
            "examItem": "L3000400",
            "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "總膽紅素",
            "examItem": "L3001700",
            "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "總蛋白",
            "examItem": "L3001800",
            "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "白蛋白",
            "examItem": "L3018100",
            "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "潛血（酵素免疫）",
            "examItem": "L4002800",
            "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "上腹部超音波",
            "examItem": "R2022000A",
            "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "鹼性磷酸酶",
            "examItem": "L3000100",
            "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "直接膽紅素",
            "examItem": "L3001710",
            "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "麩胺酸丙酮酸轉氨基酶",
            "examItem": "L3000300",
            "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "消化系統(Digestive System)",
            "examName": "球蛋白",
            "examItem": "L301810003",
            "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "血液系統(Hematology)",
            "examName": "白血球分類",
            "examItem": "L5000500",
            "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "血液系統(Hematology)",
            "examName": "血球計數",
            "examItem": "L5003200",
            "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "低/高密度脂蛋白比值",
            "examItem": "L300350002",
            "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "飯前血糖",
            "examItem": "L3000800",
            "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "低密度脂蛋白-膽固醇",
            "examItem": "L3005200",
            "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "總/高密度膽固醇比",
            "examItem": "L300350001",
            "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "靜式心電圖",
            "examItem": "L1001100A",
            "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "十年心血管疾病風險評估",
            "examItem": "R401470005",
            "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "三酸甘油酯",
            "examItem": "L3002000",
            "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "總膽固醇",
            "examItem": "L3001900",
            "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "高密度脂蛋白-膽固醇",
            "examItem": "L3003500",
            "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "心血管及代謝系統(Cardiovascular and Metabolic System)",
            "examName": "糖化血色素",
            "examItem": "L3000700",
            "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "肺部檢查(Lung Examination)",
            "examName": "胸部X光（正面）",
            "examItem": "R1010100A",
            "examMemo": "胸部X光（正面）可檢查心肺健康，幫助發現肺炎、腫瘤或心臟病等問題，及早診斷有助於後續治療。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腫瘤標記(Tumor Biomarker)",
            "examName": "前列腺特異抗原",
            "examItem": "LI004600",
            "examMemo": "前列腺特異抗原（PSA）是早期偵測攝護腺癌的參考指標。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "身高",
            "examItem": "PE00010001",
            "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "體脂肪率",
            "examItem": "PE00010019",
            "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "體重",
            "examItem": "PE00010002",
            "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "理想體重",
            "examItem": "PE00010003",
            "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "身體質量指數",
            "examItem": "PE00010006",
            "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "腰圍",
            "examItem": "PE00010017",
            "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "身體組成分析",
            "examItem": "PE00010040",
            "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "脈搏",
            "examItem": "PE00010007A",
            "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "一般檢查(General  Examination)",
            "examName": "血壓",
            "examItem": "PE00010009A",
            "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "耳鼻喉科檢查(ENT Examination)",
            "examName": "聽力檢查",
            "examItem": "T700110011B",
            "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "肌酸酐",
            "examItem": "L3001500",
            "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "尿素氮",
            "examItem": "L3001300",
            "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "腎絲球過濾率",
            "examItem": "L300150001",
            "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "尿液常規檢查",
            "examItem": "L4002000A",
            "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "腎臟泌尿系統(Kidney and Urology)",
            "examName": "尿酸",
            "examItem": "L3001400",
            "examMemo": "尿酸檢查可評估痛風及腎功能。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "其他(Other)",
            "examName": "(套檢)健康管理服務平台B2B",
            "examItem": "H0000074",
            "examMemo": "",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "其他(Other)",
            "examName": "健康調查表",
            "examItem": "PE00010038",
            "examMemo": "",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "其他(Other)",
            "examName": "早餐",
            "examItem": "F0000022",
            "examMemo": "",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "組合",
            "deptEName": "Musculoskeletal System",
            "examName": "頸椎X光",
            "examItem": "R1040300A",
            "examMemo": "頸椎X光檢查可以評估頸椎結構是否異常，幫助診斷頸椎病、脊椎受傷或退化情況，以便制定適當治療方案。",
            "examPrice": "0",
            "selectFlag": 1
        },
        {
            "deptName": "組合",
            "deptEName": "Musculoskeletal System",
            "examName": "腹部X光及腰薦椎側面X光",
            "examItem": "R1020300A",
            "examMemo": "腹部X光腸胃道等內臟的異常，幫助診斷腸阻塞、結石。腰薦椎側面X光檢測腰椎病變，協助診斷背痛原因及脊椎健康。",
            "examPrice": "0",
            "selectFlag": 1
        }
      ],
      "lastSessionId": "210f3563-88bf-4ce4-9b59-fbeb9c692edd"
      }

    } else {
      dirtyData = {
      "homeShowAnimation": false,
      "createMemberRequest": {
          "gender": "M",
          "birthday": "19770707",
          "name": "測試",
          "idNo": "A123456789",
          "cell": "0939696767",
          "email": "uuu@uu44.com",
          "password": "",
          "confirmPassword": "",
          "chartNo": "8002109631"
      },
      "loginStatus": "memberLogin",
      "myReservation": {
          "flowCode": "0",
          "bookStatus": "",
          "diffDates": 0,
          "bookDate": "",
          "caseNo": "",
          "companyNo": "",
          "familyFlag": ""
      },
      "reserveType": "1",
      "userPlanRequest": {
          "orgNo": "02",
          "gender": "M",
          "birthday": "19770707",
          "age": "48",
          "idNo": "A123456789",
          "uuid": "",
          "name": "測試",
          "cell": "0939696767",
          "email": "uuu@uu44.com",
          "telH": "",
          "telO": "",
          "zipCode": "",
          "history": [
              "既往病史_以下皆無"
          ],
          "family": [
              "家族病史_以下皆無"
          ],
          "subjectiveSymptoms": [
              "自覺症狀_以下皆無"
          ],
          "femaleStatus": false,
          "femaleMenopausal": false,
          "funcType": "0",
          "identityType": "0"
      },
      "reserveStep": 5,
      "hasFilledReserveInfo": true,
      "tempPersonalDiseaseDetails": {},
      "tempPersonalDiseaseCheck": {
          "questionId": "474",
          "questionAnswers": [
              {
                  "choiceId": "1540",
                  "answer": "1"
              }
          ]
      },
      "tempPersonalNoneOfFollowing": true,
      "tempFamilyDiseaseCheck": {
          "questionId": "483",
          "questionAnswers": [
              {
                  "choiceId": "1592",
                  "answer": "1"
              }
          ]
      },
      "tempFamilyNoneOfFollowing": true,
      "tempSubjectiveSymptomDiseaseCheck": {
          "questionId": "472",
          "questionAnswers": [
              {
                  "choiceId": "1510",
                  "answer": "1"
              }
          ]
      },
      "tempSubjectiveSymptomNoneOfFollowing": true,
      "currentHealthStep": 3,
      "questionnaireChecks": [
          {
              "questionId": "474",
              "questionAnswers": [
                  {
                      "choiceId": "1540",
                      "answer": "1"
                  }
              ]
          },
          {
              "questionId": "483",
              "questionAnswers": [
                  {
                      "choiceId": "1592",
                      "answer": "1"
                  }
              ]
          },
          {
              "questionId": "472",
              "questionAnswers": [
                  {
                      "choiceId": "1510",
                      "answer": "1"
                  }
              ]
          }
      ],
      "userPlanResponse": {
          "riskItems": [
              "消化系統",
              "心血管及代謝系統",
              "營養素與礦物質"
          ],
          "allCheckup": {
              "discountRate": "0.73748",
              "packageList": [
                  {
                      "deptName": "一般檢查",
                      "deptEName": "General Examination",
                      "examItemList": [
                          {
                              "examName": "體脂肪率",
                              "examItem": "PE00010019",
                              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6588167,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體質量指數",
                              "examItem": "PE00010006",
                              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6336039,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "腰圍",
                              "examItem": "PE00010017",
                              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.4081422,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "血壓",
                              "examItem": "PE00010009A",
                              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.36203143,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "脈搏",
                              "examItem": "PE00010007A",
                              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.02100955,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "上下肢肌力檢測",
                              "examItem": "MMS001A",
                              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.016194332,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身高",
                              "examItem": "PE00010001",
                              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "200",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "體重",
                              "examItem": "PE00010002",
                              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "理想體重",
                              "examItem": "PE00010003",
                              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體組成分析",
                              "examItem": "PE00010040",
                              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "心血管及代謝系統",
                      "deptEName": "Cardiovascular and Metabolic System",
                      "examItemList": [
                          {
                              "examName": "低密度脂蛋白-膽固醇",
                              "examItem": "L3005200",
                              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "375",
                              "rateStatus": true,
                              "abnormalRatio": 0.6037854,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總膽固醇",
                              "examItem": "L3001900",
                              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.5826974,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高敏感性C反應蛋白",
                              "examItem": "L3018400",
                              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.4319874,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "低/高密度脂蛋白比值",
                              "examItem": "L300350002",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.3974091,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前血糖",
                              "examItem": "L3000800",
                              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.38921002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "靜式心電圖",
                              "examItem": "L1001100A",
                              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "350",
                              "rateStatus": true,
                              "abnormalRatio": 0.3740002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "糖化血色素",
                              "examItem": "L3000700",
                              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.32150638,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "三酸甘油脂",
                              "examItem": "L3002000",
                              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "180",
                              "rateStatus": true,
                              "abnormalRatio": 0.31154653,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總/高密度膽固醇比",
                              "examItem": "L300350001",
                              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.27469006,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高密度脂蛋白-膽固醇",
                              "examItem": "L3003500",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.18991618,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "同半胱胺酸",
                              "examItem": "L3018300",
                              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.15489566,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "脫氫表雄酮硫酸鹽",
                              "examItem": "LI005300",
                              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.0952381,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前胰島素(含阻抗)",
                              "examItem": "LI001700A",
                              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.08467293,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "甲狀腺刺激素",
                              "examItem": "LI000400",
                              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.034355164,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "游離甲狀腺素",
                              "examItem": "LI003400",
                              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.028777989,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "十年心血管疾病風險評估",
                              "examItem": "R401470005",
                              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "全身體脂肪分析",
                              "examItem": "R1140700A",
                              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1200",
                              "rateStatus": true,
                              "abnormalRatio": 0.95320195,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "心臟超音波",
                              "examItem": "R4011700A",
                              "examMemo": "心臟超音波能無痛檢查心臟結構與功能，評估心臟疾病風險、瓣膜狀況及血流，幫助早期發現問題。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "3500",
                              "rateStatus": true,
                              "abnormalRatio": 0.7822513,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "24小時連續性心電圖監測檢查",
                              "examItem": "L1001500A",
                              "examMemo": "24小時連續性心電圖監測心臟連續性活動，評估心律不整或心臟疾病風險。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "4200",
                              "rateStatus": true,
                              "abnormalRatio": 0.7186441,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "甲狀腺超音波",
                              "examItem": "R2026000A",
                              "examMemo": "透過影像檢查甲狀腺的大小、形狀以及是否有結節或其他異常變化。常搭配血液檢驗（如TSH、T3、T4）一同評估甲狀腺健康狀況。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.71466434,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "頸動脈超音波",
                              "examItem": "R4014700A",
                              "examMemo": "頸動脈超音波檢查可以評估頸部血管的狀況，發現動脈硬化或斑塊，幫助預防中風及心血管疾病的風險。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "2000",
                              "rateStatus": true,
                              "abnormalRatio": 0.63145137,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "緻密低密度脂蛋白-超壞膽固醇",
                              "examItem": "L3005400",
                              "examMemo": "緻密低密度脂蛋白膽固醇（sdLD）被稱為超壞膽固醇，與心血管疾病風險高度相關，檢查sdLD可及早發現動脈硬化潛在風險，促進心臟健康管理。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.58426964,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "周邊動脈硬化評估",
                              "examItem": "R4014710A",
                              "examMemo": "周邊動脈硬化評估檢查可測量血管健康，過高的硬化程度可能導致血流減少，增加心血管疾病風險，有助於及早預防相關疾病。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1200",
                              "rateStatus": true,
                              "abnormalRatio": 0.3724259,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "肌酸磷酸激脢",
                              "examItem": "L3000600",
                              "examMemo": "與肌肉細胞相關，數值上升常見於劇烈運動或肌肉受損情況。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "280",
                              "rateStatus": true,
                              "abnormalRatio": 0.25373134,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "脂蛋白(a)",
                              "examItem": "FM000021",
                              "examMemo": "脂蛋白(a)結構類似LDL（壞膽固醇），過高會顯著增加心肌梗塞、中風、血管狹窄的風險",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.17082012,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "運動心電圖",
                              "examItem": "L1001200A",
                              "examMemo": "運動心電圖檢查可評估心臟在運動狀態下血壓與心電圖的變化，評估心臟是否有缺氧、心絞痛或心律不整的情形。檢查過程中，會讓在跑步機上逐漸增加運動強度，並定期測量心跳、血壓及心電圖。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "2000",
                              "rateStatus": true,
                              "abnormalRatio": 0.113300495,
                              "deptName": "心血管及代謝系統"
                          }
                      ]
                  },
                  {
                      "deptName": "男性醫學",
                      "deptEName": "Male medicine",
                      "examItemList": [
                          {
                              "examName": "睪固酮",
                              "examItem": "LI001400",
                              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.08185654,
                              "deptName": "男性醫學"
                          }
                      ]
                  },
                  {
                      "deptName": "腫瘤標記",
                      "deptEName": "Tumor Biomarker",
                      "examItemList": [
                          {
                              "examName": "CYFRA 21-1腫瘤標記",
                              "examItem": "LI006300",
                              "examMemo": "CYFRA 21-1是肺部腫瘤參考指標，可作為肺癌追蹤監測與輔助診斷",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1000",
                              "rateStatus": true,
                              "abnormalRatio": 0.2621951,
                              "deptName": "腫瘤標記"
                          },
                          {
                              "examName": "游離前列腺特異抗原",
                              "examItem": "LI006900",
                              "examMemo": "游離前列腺特異抗原（FreePSA）是前列腺健康的參考指標，特別是前列腺癌，提升及早診斷和治療的機會。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.24683367,
                              "deptName": "腫瘤標記"
                          },
                          {
                              "examName": "腫瘤組織多胜脢抗原",
                              "examItem": "LI005600",
                              "examMemo": "腫瘤組織多胜脢抗原（TPA）是上皮細胞腫瘤的標記。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1000",
                              "rateStatus": true,
                              "abnormalRatio": 0.19399539,
                              "deptName": "腫瘤標記"
                          },
                          {
                              "examName": "EB病毒抗體IgA",
                              "examItem": "L2004200A",
                              "examMemo": "EB病毒抗體IgA檢查評估是否感染EB病毒，常用於鼻咽癌高風險族群的初步篩檢",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.17175888,
                              "deptName": "腫瘤標記"
                          }
                      ]
                  },
                  {
                      "deptName": "肺部檢查",
                      "deptEName": "Lung Examination",
                      "examItemList": [
                          {
                              "examName": "胸部X光（正面及左側面）",
                              "examItem": "R132001DA",
                              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "720",
                              "rateStatus": true,
                              "abnormalRatio": 0.33959147,
                              "deptName": "肺部檢查"
                          },
                          {
                              "examName": "肺功能檢查",
                              "examItem": "L1001400A",
                              "examMemo": "肺功能檢查評估肺部的呼吸能力，幫助診斷慢性阻塞性肺病等疾病，及早發現問題可改善呼吸健康。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "350",
                              "rateStatus": true,
                              "abnormalRatio": 0.24436091,
                              "deptName": "肺部檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "風濕免疫系統",
                      "deptEName": "Rheumatology and Immunology",
                      "examItemList": [
                          {
                              "examName": "全免疫球蛋白E定量",
                              "examItem": "L2001300",
                              "examMemo": "全免疫球蛋白E（IgE）定量可評估過敏反應及免疫系統狀況，IgE高可能有過敏、氣喘。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.31327432,
                              "deptName": "風濕免疫系統"
                          },
                          {
                              "examName": "抗核抗體",
                              "examItem": "L2003100",
                              "examMemo": "抗核抗體（ANA）是一種自體免疫標記，檢查可協助診斷紅斑性狼瘡及其他自體免疫疾病，陽性結果需要進一步評估。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.12101911,
                              "deptName": "風濕免疫系統"
                          }
                      ]
                  },
                  {
                      "deptName": "耳鼻喉科檢查",
                      "deptEName": "ENT Examination",
                      "examItemList": [
                          {
                              "examName": "密閉式純音聽力檢查",
                              "examItem": "T700110051A",
                              "examMemo": "密閉式純音聽力檢查可評估個人聽力狀況，幫助識別聽力損傷。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.3457249,
                              "deptName": "耳鼻喉科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "營養素與礦物質",
                      "deptEName": "Nutrient & Mineral",
                      "examItemList": [
                          {
                              "examName": "維他命 D",
                              "examItem": "VIT0002",
                              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.88415545,
                              "deptName": "營養素與礦物質"
                          },
                          {
                              "examName": "維他命 B12",
                              "examItem": "VIT0005",
                              "examMemo": "維他命B12檢查能評估血液中B12濃度，低可能導致貧血、神經問題及認知障礙，早期發現有助於預防這些健康問題。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.26461643,
                              "deptName": "營養素與礦物質"
                          },
                          {
                              "examName": "葉酸",
                              "examItem": "VIT0006",
                              "examMemo": "葉酸是合成DNA和紅血球的重要營養素，缺乏可能導致貧血和神經管缺陷。檢查葉酸有助於評估營養狀態及孕婦胎兒健康。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.17286652,
                              "deptName": "營養素與礦物質"
                          }
                      ]
                  },
                  {
                      "deptName": "血液系統",
                      "deptEName": "Hematology",
                      "examItemList": [
                          {
                              "examName": "鐵蛋白",
                              "examItem": "L3004500",
                              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.48436248,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "血球計數",
                              "examItem": "L5003200",
                              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "330",
                              "rateStatus": true,
                              "abnormalRatio": 0.24270557,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "白血球分類",
                              "examItem": "L5000500",
                              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.10483387,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "纖維蛋白原",
                              "examItem": "L5002600",
                              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "血液系統"
                          }
                      ]
                  },
                  {
                      "deptName": "腎臟泌尿系統",
                      "deptEName": "Kidney and Urology",
                      "examItemList": [
                          {
                              "examName": "腎絲球過濾率",
                              "examItem": "L300150001",
                              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.46638596,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿酸",
                              "examItem": "L3001400",
                              "examMemo": "尿酸檢查可評估痛風及腎功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.3110547,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿液常規檢查",
                              "examItem": "L4002000A",
                              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "170",
                              "rateStatus": true,
                              "abnormalRatio": 0.07999199,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "肌酸酐",
                              "examItem": "L3001500",
                              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.06713337,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "電解質",
                              "examItem": "L3002100A",
                              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "360",
                              "rateStatus": true,
                              "abnormalRatio": 0.054231226,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿素氮",
                              "examItem": "L3001300",
                              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.020641107,
                              "deptName": "腎臟泌尿系統"
                          }
                      ]
                  },
                  {
                      "deptName": "脊椎骨骼系統",
                      "deptEName": "Skeletal System",
                      "examItemList": [
                          {
                              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
                              "examItem": "R1040501A",
                              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "900",
                              "rateStatus": true,
                              "abnormalRatio": 0.83651227,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "腰薦椎正面及側面X光",
                              "examItem": "R1041200A",
                              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.81395346,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "雙膝X光",
                              "examItem": "R1054000A",
                              "examMemo": "雙膝X光主要用於檢查膝關節的骨骼結構、關節腫脹或損傷，協助診斷關節炎、骨折等疾病，確保膝蓋的健康狀態。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.28025478,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "骨鈣素",
                              "examItem": "L3004600",
                              "examMemo": "骨鈣素可評估骨質新生速度，有助了解骨骼健康與骨質疏鬆風險",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "700",
                              "rateStatus": true,
                              "abnormalRatio": 0.24752475,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "左髖關節骨質密度",
                              "examItem": "R1140400A",
                              "examMemo": "左髖關節骨質密度檢查能評估骨骼強度，低密度可能預示骨質疏鬆風險，及早檢查有助於預防骨折及改善整體骨健康。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1000",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "脊椎骨骼系統"
                          }
                      ]
                  },
                  {
                      "deptName": "理學檢查",
                      "deptEName": "Physical Examination",
                      "examItemList": [
                          {
                              "examName": "理學檢查",
                              "examItem": "PE00010023A",
                              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.14126594,
                              "deptName": "理學檢查"
                          },
                          {
                              "examName": "個人主訴",
                              "examItem": "HI000001A",
                              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "理學檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "影像醫學",
                      "deptEName": "CT/MRI",
                      "examItemList": [
                          {
                              "examName": "冠狀動脈鈣化積分",
                              "examItem": "R9003800AH",
                              "examMemo": "檢查心臟冠狀動脈鈣化程度，評估心肌梗塞風險（若有裝置心臟支架、心律調節器、人工心臟瓣膜或胸椎打釘，無法排檢）",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "6500",
                              "rateStatus": false,
                              "abnormalRatio": 0.19708535,
                              "deptName": "影像醫學"
                          }
                      ]
                  },
                  {
                      "deptName": "眼科檢查",
                      "deptEName": "Eye Examination",
                      "examItemList": [
                          {
                              "examName": "視力",
                              "examItem": "PE00040001B",
                              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.24298806,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼底斷層掃描",
                              "examItem": "PE000001A",
                              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.22279978,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "石原色覺檢查表",
                              "examItem": "PE00040014",
                              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.049161676,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼壓",
                              "examItem": "PE00040004B",
                              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.042481624,
                              "deptName": "眼科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "消化系統",
                      "deptEName": "Digestive System",
                      "examItemList": [
                          {
                              "examName": "上腹部超音波",
                              "examItem": "R2022000A",
                              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.90277964,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸丙酮酸轉氨基酶",
                              "examItem": "L3000300",
                              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.32915446,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "直接膽紅素",
                              "examItem": "L3001710",
                              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.14638714,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗原",
                              "examItem": "L2001900",
                              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.13758251,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸苯醋酸轉氨基酶",
                              "examItem": "L3000200",
                              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.11648777,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總膽紅素",
                              "examItem": "L3001700",
                              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.114548095,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸轉肽酶",
                              "examItem": "L3000400",
                              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.09633882,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "白蛋白",
                              "examItem": "L3018100",
                              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.056706805,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "鹼性磷酸酶",
                              "examItem": "L3000100",
                              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.023285212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "C型肝炎抗體測定",
                              "examItem": "LG001400",
                              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.009078212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總蛋白",
                              "examItem": "L3001800",
                              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.008030916,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗體",
                              "examItem": "L2002000",
                              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "球蛋白",
                              "examItem": "L301810003",
                              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
                              "examItem": "LB000401Q",
                              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "6500",
                              "rateStatus": true,
                              "abnormalRatio": 0.9862259,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "胃鏡",
                              "examItem": "LB000201C",
                              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "3500",
                              "rateStatus": true,
                              "abnormalRatio": 0.96851075,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "幽門桿菌培養鑑定檢查",
                              "examItem": "LB002600",
                              "examMemo": "幽門桿菌培養鑑定檢查可確認是否感染此細菌，該菌與胃潰瘍及胃炎有關。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "300",
                              "rateStatus": false,
                              "abnormalRatio": 0.29605263,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎核心抗體",
                              "examItem": "L2002300",
                              "examMemo": "B型肝炎核心抗體檢查可判斷是否曾感染B型肝炎病毒，了解個體是否具免疫力或需要進一步檢查，協助評估肝臟健康風險。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.17991632,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "胰澱粉脢",
                              "examItem": "L6000800",
                              "examMemo": "胰澱粉脢是消化酶，主要分解澱粉為葡萄糖。檢查其活性可評估胰腺功能，幫助診斷胰臟炎或其他消化問題。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "220",
                              "rateStatus": true,
                              "abnormalRatio": 0.10427136,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "(新)雙項麻醉",
                              "examItem": "PE001006",
                              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "5800",
                              "rateStatus": false,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          }
                      ]
                  },
                  {
                      "deptName": "神經系統",
                      "deptEName": "Neurology",
                      "examItemList": [
                          {
                              "examName": "HRV自律神經",
                              "examItem": "L1008000A",
                              "examMemo": "HRV自律神經檢查能評估自主神經系統的平衡，反映壓力反應和健康狀態。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1400",
                              "rateStatus": true,
                              "abnormalRatio": 0.7209613,
                              "deptName": "神經系統"
                          }
                      ]
                  }
              ],
              "abnormalCnt": "0",
              "potentialCnt": "33"
          },
          "aiExclusive": {
              "discountRate": "0.73266",
              "packageList": [
                  {
                      "deptName": "一般檢查",
                      "deptEName": "General Examination",
                      "examItemList": [
                          {
                              "examName": "體脂肪率",
                              "examItem": "PE00010019",
                              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6588167,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體質量指數",
                              "examItem": "PE00010006",
                              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6336039,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "腰圍",
                              "examItem": "PE00010017",
                              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.4081422,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "血壓",
                              "examItem": "PE00010009A",
                              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.36203143,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "脈搏",
                              "examItem": "PE00010007A",
                              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.02100955,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "上下肢肌力檢測",
                              "examItem": "MMS001A",
                              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.016194332,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身高",
                              "examItem": "PE00010001",
                              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "200",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "體重",
                              "examItem": "PE00010002",
                              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "理想體重",
                              "examItem": "PE00010003",
                              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體組成分析",
                              "examItem": "PE00010040",
                              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "心血管及代謝系統",
                      "deptEName": "Cardiovascular and Metabolic System",
                      "examItemList": [
                          {
                              "examName": "低密度脂蛋白-膽固醇",
                              "examItem": "L3005200",
                              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "375",
                              "rateStatus": true,
                              "abnormalRatio": 0.6037854,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總膽固醇",
                              "examItem": "L3001900",
                              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.5826974,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高敏感性C反應蛋白",
                              "examItem": "L3018400",
                              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.4319874,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "低/高密度脂蛋白比值",
                              "examItem": "L300350002",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.3974091,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前血糖",
                              "examItem": "L3000800",
                              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.38921002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "靜式心電圖",
                              "examItem": "L1001100A",
                              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "350",
                              "rateStatus": true,
                              "abnormalRatio": 0.3740002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "糖化血色素",
                              "examItem": "L3000700",
                              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.32150638,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "三酸甘油脂",
                              "examItem": "L3002000",
                              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "180",
                              "rateStatus": true,
                              "abnormalRatio": 0.31154653,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總/高密度膽固醇比",
                              "examItem": "L300350001",
                              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.27469006,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高密度脂蛋白-膽固醇",
                              "examItem": "L3003500",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.18991618,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "同半胱胺酸",
                              "examItem": "L3018300",
                              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.15489566,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "脫氫表雄酮硫酸鹽",
                              "examItem": "LI005300",
                              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.0952381,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前胰島素(含阻抗)",
                              "examItem": "LI001700A",
                              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.08467293,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "甲狀腺刺激素",
                              "examItem": "LI000400",
                              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.034355164,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "游離甲狀腺素",
                              "examItem": "LI003400",
                              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.028777989,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "十年心血管疾病風險評估",
                              "examItem": "R401470005",
                              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "全身體脂肪分析",
                              "examItem": "R1140700A",
                              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "1200",
                              "rateStatus": true,
                              "abnormalRatio": 0.95320195,
                              "deptName": "心血管及代謝系統"
                          }
                      ]
                  },
                  {
                      "deptName": "腎臟泌尿系統",
                      "deptEName": "Kidney and Urology",
                      "examItemList": [
                          {
                              "examName": "腎絲球過濾率",
                              "examItem": "L300150001",
                              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.46638596,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿酸",
                              "examItem": "L3001400",
                              "examMemo": "尿酸檢查可評估痛風及腎功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.3110547,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿液常規檢查",
                              "examItem": "L4002000A",
                              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "170",
                              "rateStatus": true,
                              "abnormalRatio": 0.07999199,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "肌酸酐",
                              "examItem": "L3001500",
                              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.06713337,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "電解質",
                              "examItem": "L3002100A",
                              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "360",
                              "rateStatus": true,
                              "abnormalRatio": 0.054231226,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿素氮",
                              "examItem": "L3001300",
                              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.020641107,
                              "deptName": "腎臟泌尿系統"
                          }
                      ]
                  },
                  {
                      "deptName": "男性醫學",
                      "deptEName": "Male medicine",
                      "examItemList": [
                          {
                              "examName": "睪固酮",
                              "examItem": "LI001400",
                              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.08185654,
                              "deptName": "男性醫學"
                          }
                      ]
                  },
                  {
                      "deptName": "脊椎骨骼系統",
                      "deptEName": "Skeletal System",
                      "examItemList": [
                          {
                              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
                              "examItem": "R1040501A",
                              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "900",
                              "rateStatus": true,
                              "abnormalRatio": 0.83651227,
                              "deptName": "脊椎骨骼系統"
                          },
                          {
                              "examName": "腰薦椎正面及側面X光",
                              "examItem": "R1041200A",
                              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.81395346,
                              "deptName": "脊椎骨骼系統"
                          }
                      ]
                  },
                  {
                      "deptName": "理學檢查",
                      "deptEName": "Physical Examination",
                      "examItemList": [
                          {
                              "examName": "理學檢查",
                              "examItem": "PE00010023A",
                              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.14126594,
                              "deptName": "理學檢查"
                          },
                          {
                              "examName": "個人主訴",
                              "examItem": "HI000001A",
                              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "理學檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "肺部檢查",
                      "deptEName": "Lung Examination",
                      "examItemList": [
                          {
                              "examName": "胸部X光（正面及左側面）",
                              "examItem": "R132001DA",
                              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "720",
                              "rateStatus": true,
                              "abnormalRatio": 0.33959147,
                              "deptName": "肺部檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "耳鼻喉科檢查",
                      "deptEName": "ENT Examination",
                      "examItemList": [
                          {
                              "examName": "聽力檢查",
                              "examItem": "T700110011B",
                              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "250",
                              "rateStatus": true,
                              "abnormalRatio": 0.09931259,
                              "deptName": "耳鼻喉科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "眼科檢查",
                      "deptEName": "Eye Examination",
                      "examItemList": [
                          {
                              "examName": "視力",
                              "examItem": "PE00040001B",
                              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.24298806,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼底斷層掃描",
                              "examItem": "PE000001A",
                              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.22279978,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "石原色覺檢查表",
                              "examItem": "PE00040014",
                              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.049161676,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼壓",
                              "examItem": "PE00040004B",
                              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.042481624,
                              "deptName": "眼科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "營養素與礦物質",
                      "deptEName": "Nutrient & Mineral",
                      "examItemList": [
                          {
                              "examName": "維他命 D",
                              "examItem": "VIT0002",
                              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.88415545,
                              "deptName": "營養素與礦物質"
                          }
                      ]
                  },
                  {
                      "deptName": "消化系統",
                      "deptEName": "Digestive System",
                      "examItemList": [
                          {
                              "examName": "上腹部超音波",
                              "examItem": "R2022000A",
                              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.90277964,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸丙酮酸轉氨基酶",
                              "examItem": "L3000300",
                              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.32915446,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "直接膽紅素",
                              "examItem": "L3001710",
                              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.14638714,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗原",
                              "examItem": "L2001900",
                              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.13758251,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸苯醋酸轉氨基酶",
                              "examItem": "L3000200",
                              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.11648777,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總膽紅素",
                              "examItem": "L3001700",
                              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.114548095,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸轉肽酶",
                              "examItem": "L3000400",
                              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.09633882,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "白蛋白",
                              "examItem": "L3018100",
                              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.056706805,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "鹼性磷酸酶",
                              "examItem": "L3000100",
                              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.023285212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "C型肝炎抗體測定",
                              "examItem": "LG001400",
                              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.009078212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總蛋白",
                              "examItem": "L3001800",
                              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.008030916,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗體",
                              "examItem": "L2002000",
                              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "球蛋白",
                              "examItem": "L301810003",
                              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
                              "examItem": "LB000401Q",
                              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "6500",
                              "rateStatus": true,
                              "abnormalRatio": 0.9862259,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "胃鏡",
                              "examItem": "LB000201C",
                              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "3500",
                              "rateStatus": true,
                              "abnormalRatio": 0.96851075,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "(新)雙項麻醉",
                              "examItem": "PE001006",
                              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
                              "examType": "潛在疾病風險檢查建議",
                              "examPrice": "5800",
                              "rateStatus": false,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          }
                      ]
                  },
                  {
                      "deptName": "血液系統",
                      "deptEName": "Hematology",
                      "examItemList": [
                          {
                              "examName": "鐵蛋白",
                              "examItem": "L3004500",
                              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.48436248,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "血球計數",
                              "examItem": "L5003200",
                              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "330",
                              "rateStatus": true,
                              "abnormalRatio": 0.24270557,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "白血球分類",
                              "examItem": "L5000500",
                              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.10483387,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "纖維蛋白原",
                              "examItem": "L5002600",
                              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "血液系統"
                          }
                      ]
                  }
              ],
              "abnormalCnt": "0",
              "potentialCnt": "6"
          },
          "basicCheckup": {
              "discountRate": "0.71326",
              "packageList": [
                  {
                      "deptName": "一般檢查",
                      "deptEName": "General Examination",
                      "examItemList": [
                          {
                              "examName": "上下肢肌力檢測",
                              "examItem": "MMS001A",
                              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.016194332,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身高",
                              "examItem": "PE00010001",
                              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "200",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "體重",
                              "examItem": "PE00010002",
                              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "理想體重",
                              "examItem": "PE00010003",
                              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體質量指數",
                              "examItem": "PE00010006",
                              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6336039,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "脈搏",
                              "examItem": "PE00010007A",
                              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.02100955,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "血壓",
                              "examItem": "PE00010009A",
                              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.36203143,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "腰圍",
                              "examItem": "PE00010017",
                              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.4081422,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "體脂肪率",
                              "examItem": "PE00010019",
                              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.6588167,
                              "deptName": "一般檢查"
                          },
                          {
                              "examName": "身體組成分析",
                              "examItem": "PE00010040",
                              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "一般檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "心血管及代謝系統",
                      "deptEName": "Cardiovascular and Metabolic System",
                      "examItemList": [
                          {
                              "examName": "靜式心電圖",
                              "examItem": "L1001100A",
                              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "350",
                              "rateStatus": true,
                              "abnormalRatio": 0.3740002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "糖化血色素",
                              "examItem": "L3000700",
                              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.32150638,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前血糖",
                              "examItem": "L3000800",
                              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.38921002,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總膽固醇",
                              "examItem": "L3001900",
                              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.5826974,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "三酸甘油脂",
                              "examItem": "L3002000",
                              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "180",
                              "rateStatus": true,
                              "abnormalRatio": 0.31154653,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高密度脂蛋白-膽固醇",
                              "examItem": "L3003500",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.18991618,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "總/高密度膽固醇比",
                              "examItem": "L300350001",
                              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.27469006,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "低/高密度脂蛋白比值",
                              "examItem": "L300350002",
                              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.3974091,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "低密度脂蛋白-膽固醇",
                              "examItem": "L3005200",
                              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "375",
                              "rateStatus": true,
                              "abnormalRatio": 0.6037854,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "同半胱胺酸",
                              "examItem": "L3018300",
                              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.15489566,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "高敏感性C反應蛋白",
                              "examItem": "L3018400",
                              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.4319874,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "甲狀腺刺激素",
                              "examItem": "LI000400",
                              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.034355164,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "飯前胰島素(含阻抗)",
                              "examItem": "LI001700A",
                              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.08467293,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "游離甲狀腺素",
                              "examItem": "LI003400",
                              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.028777989,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "脫氫表雄酮硫酸鹽",
                              "examItem": "LI005300",
                              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "500",
                              "rateStatus": true,
                              "abnormalRatio": 0.0952381,
                              "deptName": "心血管及代謝系統"
                          },
                          {
                              "examName": "十年心血管疾病風險評估",
                              "examItem": "R401470005",
                              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "心血管及代謝系統"
                          }
                      ]
                  },
                  {
                      "deptName": "腎臟泌尿系統",
                      "deptEName": "Kidney and Urology",
                      "examItemList": [
                          {
                              "examName": "尿素氮",
                              "examItem": "L3001300",
                              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.020641107,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿酸",
                              "examItem": "L3001400",
                              "examMemo": "尿酸檢查可評估痛風及腎功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.3110547,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "肌酸酐",
                              "examItem": "L3001500",
                              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.06713337,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "腎絲球過濾率",
                              "examItem": "L300150001",
                              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0.46638596,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "電解質",
                              "examItem": "L3002100A",
                              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "360",
                              "rateStatus": true,
                              "abnormalRatio": 0.054231226,
                              "deptName": "腎臟泌尿系統"
                          },
                          {
                              "examName": "尿液常規檢查",
                              "examItem": "L4002000A",
                              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "170",
                              "rateStatus": true,
                              "abnormalRatio": 0.07999199,
                              "deptName": "腎臟泌尿系統"
                          }
                      ]
                  },
                  {
                      "deptName": "男性醫學",
                      "deptEName": "Male medicine",
                      "examItemList": [
                          {
                              "examName": "睪固酮",
                              "examItem": "LI001400",
                              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "600",
                              "rateStatus": true,
                              "abnormalRatio": 0.08185654,
                              "deptName": "男性醫學"
                          }
                      ]
                  },
                  {
                      "deptName": "理學檢查",
                      "deptEName": "Physical Examination",
                      "examItemList": [
                          {
                              "examName": "個人主訴",
                              "examItem": "HI000001A",
                              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "理學檢查"
                          },
                          {
                              "examName": "理學檢查",
                              "examItem": "PE00010023A",
                              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.14126594,
                              "deptName": "理學檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "肺部檢查",
                      "deptEName": "Lung Examination",
                      "examItemList": [
                          {
                              "examName": "胸部X光（正面及左側面）",
                              "examItem": "R132001DA",
                              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "720",
                              "rateStatus": true,
                              "abnormalRatio": 0.33959147,
                              "deptName": "肺部檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "營養素與礦物質",
                      "deptEName": "Nutrient & Mineral",
                      "examItemList": [
                          {
                              "examName": "維他命 D",
                              "examItem": "VIT0002",
                              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "800",
                              "rateStatus": true,
                              "abnormalRatio": 0.88415545,
                              "deptName": "營養素與礦物質"
                          }
                      ]
                  },
                  {
                      "deptName": "耳鼻喉科檢查",
                      "deptEName": "ENT Examination",
                      "examItemList": [
                          {
                              "examName": "聽力檢查",
                              "examItem": "T700110011B",
                              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "250",
                              "rateStatus": true,
                              "abnormalRatio": 0.09931259,
                              "deptName": "耳鼻喉科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "眼科檢查",
                      "deptEName": "Eye Examination",
                      "examItemList": [
                          {
                              "examName": "眼底斷層掃描",
                              "examItem": "PE000001A",
                              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.22279978,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "視力",
                              "examItem": "PE00040001B",
                              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.24298806,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "眼壓",
                              "examItem": "PE00040004B",
                              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.042481624,
                              "deptName": "眼科檢查"
                          },
                          {
                              "examName": "石原色覺檢查表",
                              "examItem": "PE00040014",
                              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "50",
                              "rateStatus": true,
                              "abnormalRatio": 0.049161676,
                              "deptName": "眼科檢查"
                          }
                      ]
                  },
                  {
                      "deptName": "消化系統",
                      "deptEName": "Digestive System",
                      "examItemList": [
                          {
                              "examName": "B型肝炎表面抗原",
                              "examItem": "L2001900",
                              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": 0.13758251,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "B型肝炎表面抗體",
                              "examItem": "L2002000",
                              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "鹼性磷酸酶",
                              "examItem": "L3000100",
                              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.023285212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸苯醋酸轉氨基酶",
                              "examItem": "L3000200",
                              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.11648777,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸丙酮酸轉氨基酶",
                              "examItem": "L3000300",
                              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.32915446,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "麩胺酸轉肽酶",
                              "examItem": "L3000400",
                              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.09633882,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總膽紅素",
                              "examItem": "L3001700",
                              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.114548095,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "直接膽紅素",
                              "examItem": "L3001710",
                              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.14638714,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "總蛋白",
                              "examItem": "L3001800",
                              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.008030916,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "白蛋白",
                              "examItem": "L3018100",
                              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "90",
                              "rateStatus": true,
                              "abnormalRatio": 0.056706805,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "球蛋白",
                              "examItem": "L301810003",
                              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "0",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "潛血（酵素免疫）",
                              "examItem": "L4002800",
                              "examMemo": "潛血（酵素免疫）檢查是一種非侵入性篩檢工具，可檢測腸道是否有 瘜肉、腫瘤、發炎、痔瘡等相關疾病造成出血",
                              "examType": "優先必要檢查項目",
                              "examPrice": "180",
                              "rateStatus": true,
                              "abnormalRatio": 0.033580706,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "C型肝炎抗體測定",
                              "examItem": "LG001400",
                              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "450",
                              "rateStatus": true,
                              "abnormalRatio": 0.009078212,
                              "deptName": "消化系統"
                          },
                          {
                              "examName": "上腹部超音波",
                              "examItem": "R2022000A",
                              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "1500",
                              "rateStatus": true,
                              "abnormalRatio": 0.90277964,
                              "deptName": "消化系統"
                          }
                      ]
                  },
                  {
                      "deptName": "血液系統",
                      "deptEName": "Hematology",
                      "examItemList": [
                          {
                              "examName": "鐵蛋白",
                              "examItem": "L3004500",
                              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "400",
                              "rateStatus": true,
                              "abnormalRatio": 0.48436248,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "白血球分類",
                              "examItem": "L5000500",
                              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "100",
                              "rateStatus": true,
                              "abnormalRatio": 0.10483387,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "纖維蛋白原",
                              "examItem": "L5002600",
                              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "300",
                              "rateStatus": true,
                              "abnormalRatio": null,
                              "deptName": "血液系統"
                          },
                          {
                              "examName": "血球計數",
                              "examItem": "L5003200",
                              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
                              "examType": "優先必要檢查項目",
                              "examPrice": "330",
                              "rateStatus": true,
                              "abnormalRatio": 0.24270557,
                              "deptName": "血液系統"
                          }
                      ]
                  }
              ],
              "abnormalCnt": "0",
              "potentialCnt": "0"
          }
      },
      "selectedPackage": "智能專屬型",
      "examItemList": [
          {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6588167,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體質量指數",
              "examItem": "PE00010006",
              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6336039,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰圍",
              "examItem": "PE00010017",
              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.4081422,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.36203143,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脈搏",
              "examItem": "PE00010007A",
              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.02100955,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上下肢肌力檢測",
              "examItem": "MMS001A",
              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.016194332,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身高",
              "examItem": "PE00010001",
              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "200",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "體重",
              "examItem": "PE00010002",
              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理想體重",
              "examItem": "PE00010003",
              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體組成分析",
              "examItem": "PE00010040",
              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低密度脂蛋白-膽固醇",
              "examItem": "L3005200",
              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "375",
              "rateStatus": true,
              "abnormalRatio": 0.6037854,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽固醇",
              "examItem": "L3001900",
              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.5826974,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高敏感性C反應蛋白",
              "examItem": "L3018400",
              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.4319874,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低/高密度脂蛋白比值",
              "examItem": "L300350002",
              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.3974091,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前血糖",
              "examItem": "L3000800",
              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.38921002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "350",
              "rateStatus": true,
              "abnormalRatio": 0.3740002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "糖化血色素",
              "examItem": "L3000700",
              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.32150638,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "三酸甘油脂",
              "examItem": "L3002000",
              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "180",
              "rateStatus": true,
              "abnormalRatio": 0.31154653,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總/高密度膽固醇比",
              "examItem": "L300350001",
              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.27469006,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高密度脂蛋白-膽固醇",
              "examItem": "L3003500",
              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.18991618,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "同半胱胺酸",
              "examItem": "L3018300",
              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "800",
              "rateStatus": true,
              "abnormalRatio": 0.15489566,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脫氫表雄酮硫酸鹽",
              "examItem": "LI005300",
              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
              "examType": "優先必要檢查項目",
              "examPrice": "500",
              "rateStatus": true,
              "abnormalRatio": 0.0952381,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前胰島素(含阻抗)",
              "examItem": "LI001700A",
              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0.08467293,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "甲狀腺刺激素",
              "examItem": "LI000400",
              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.034355164,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "游離甲狀腺素",
              "examItem": "LI003400",
              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
              "examType": "優先必要檢查項目",
              "examPrice": "500",
              "rateStatus": true,
              "abnormalRatio": 0.028777989,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "十年心血管疾病風險評估",
              "examItem": "R401470005",
              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "全身體脂肪分析",
              "examItem": "R1140700A",
              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "1200",
              "rateStatus": true,
              "abnormalRatio": 0.95320195,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腎絲球過濾率",
              "examItem": "L300150001",
              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.46638596,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿酸",
              "examItem": "L3001400",
              "examMemo": "尿酸檢查可評估痛風及腎功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.3110547,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿液常規檢查",
              "examItem": "L4002000A",
              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
              "examType": "優先必要檢查項目",
              "examPrice": "170",
              "rateStatus": true,
              "abnormalRatio": 0.07999199,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "肌酸酐",
              "examItem": "L3001500",
              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.06713337,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "電解質",
              "examItem": "L3002100A",
              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
              "examType": "優先必要檢查項目",
              "examPrice": "360",
              "rateStatus": true,
              "abnormalRatio": 0.054231226,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿素氮",
              "examItem": "L3001300",
              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.020641107,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "睪固酮",
              "examItem": "LI001400",
              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "600",
              "rateStatus": true,
              "abnormalRatio": 0.08185654,
              "deptName": "男性醫學",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
              "examItem": "R1040501A",
              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "900",
              "rateStatus": true,
              "abnormalRatio": 0.83651227,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰薦椎正面及側面X光",
              "examItem": "R1041200A",
              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "600",
              "rateStatus": true,
              "abnormalRatio": 0.81395346,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理學檢查",
              "examItem": "PE00010023A",
              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.14126594,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "個人主訴",
              "examItem": "HI000001A",
              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胸部X光（正面及左側面）",
              "examItem": "R132001DA",
              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
              "examType": "優先必要檢查項目",
              "examPrice": "720",
              "rateStatus": true,
              "abnormalRatio": 0.33959147,
              "deptName": "肺部檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "聽力檢查",
              "examItem": "T700110011B",
              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
              "examType": "優先必要檢查項目",
              "examPrice": "250",
              "rateStatus": true,
              "abnormalRatio": 0.09931259,
              "deptName": "耳鼻喉科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "examType": "優先必要檢查項目",
              "examPrice": "50",
              "rateStatus": true,
              "abnormalRatio": 0.24298806,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼底斷層掃描",
              "examItem": "PE000001A",
              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
              "examType": "優先必要檢查項目",
              "examPrice": "1500",
              "rateStatus": true,
              "abnormalRatio": 0.22279978,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "石原色覺檢查表",
              "examItem": "PE00040014",
              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "50",
              "rateStatus": true,
              "abnormalRatio": 0.049161676,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.042481624,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "維他命 D",
              "examItem": "VIT0002",
              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
              "examType": "優先必要檢查項目",
              "examPrice": "800",
              "rateStatus": true,
              "abnormalRatio": 0.88415545,
              "deptName": "營養素與礦物質",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上腹部超音波",
              "examItem": "R2022000A",
              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "1500",
              "rateStatus": true,
              "abnormalRatio": 0.90277964,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸丙酮酸轉氨基酶",
              "examItem": "L3000300",
              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.32915446,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "直接膽紅素",
              "examItem": "L3001710",
              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.14638714,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.13758251,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸苯醋酸轉氨基酶",
              "examItem": "L3000200",
              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.11648777,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽紅素",
              "examItem": "L3001700",
              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.114548095,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸轉肽酶",
              "examItem": "L3000400",
              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.09633882,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白蛋白",
              "examItem": "L3018100",
              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.056706805,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鹼性磷酸酶",
              "examItem": "L3000100",
              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.023285212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "C型肝炎抗體測定",
              "examItem": "LG001400",
              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.009078212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總蛋白",
              "examItem": "L3001800",
              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.008030916,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗體",
              "examItem": "L2002000",
              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "球蛋白",
              "examItem": "L301810003",
              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
              "examItem": "LB000401Q",
              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "6500",
              "rateStatus": true,
              "abnormalRatio": 0.9862259,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胃鏡",
              "examItem": "LB000201C",
              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "3500",
              "rateStatus": true,
              "abnormalRatio": 0.96851075,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "(新)雙項麻醉",
              "examItem": "PE001006",
              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "5800",
              "rateStatus": false,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鐵蛋白",
              "examItem": "L3004500",
              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0.48436248,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血球計數",
              "examItem": "L5003200",
              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.24270557,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白血球分類",
              "examItem": "L5000500",
              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.10483387,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "纖維蛋白原",
              "examItem": "L5002600",
              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          }
      ],
      "packagePrice": "26410",
      "originalPrice": 26410,
      "discountRate": "0.73266",
      "selectedPackagePlanType": "2",
      "aiChatbotExamItemList": [
          {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6588167,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體質量指數",
              "examItem": "PE00010006",
              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6336039,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰圍",
              "examItem": "PE00010017",
              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.4081422,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.36203143,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脈搏",
              "examItem": "PE00010007A",
              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.02100955,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上下肢肌力檢測",
              "examItem": "MMS001A",
              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0.016194332,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身高",
              "examItem": "PE00010001",
              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "150",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "體重",
              "examItem": "PE00010002",
              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理想體重",
              "examItem": "PE00010003",
              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體組成分析",
              "examItem": "PE00010040",
              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低密度脂蛋白-膽固醇",
              "examItem": "L3005200",
              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "280",
              "rateStatus": true,
              "abnormalRatio": 0.6037854,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽固醇",
              "examItem": "L3001900",
              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0.5826974,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高敏感性C反應蛋白",
              "examItem": "L3018400",
              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0.4319874,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低/高密度脂蛋白比值",
              "examItem": "L300350002",
              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.3974091,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前血糖",
              "examItem": "L3000800",
              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.38921002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "260",
              "rateStatus": true,
              "abnormalRatio": 0.3740002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "糖化血色素",
              "examItem": "L3000700",
              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0.32150638,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "三酸甘油脂",
              "examItem": "L3002000",
              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "140",
              "rateStatus": true,
              "abnormalRatio": 0.31154653,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總/高密度膽固醇比",
              "examItem": "L300350001",
              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.27469006,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高密度脂蛋白-膽固醇",
              "examItem": "L3003500",
              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0.18991618,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "同半胱胺酸",
              "examItem": "L3018300",
              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "590",
              "rateStatus": true,
              "abnormalRatio": 0.15489566,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脫氫表雄酮硫酸鹽",
              "examItem": "LI005300",
              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
              "examType": "優先必要檢查項目",
              "examPrice": "370",
              "rateStatus": true,
              "abnormalRatio": 0.0952381,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前胰島素(含阻抗)",
              "examItem": "LI001700A",
              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.08467293,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "甲狀腺刺激素",
              "examItem": "LI000400",
              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.034355164,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "游離甲狀腺素",
              "examItem": "LI003400",
              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
              "examType": "優先必要檢查項目",
              "examPrice": "370",
              "rateStatus": true,
              "abnormalRatio": 0.028777989,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "十年心血管疾病風險評估",
              "examItem": "R401470005",
              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "全身體脂肪分析",
              "examItem": "R1140700A",
              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "880",
              "rateStatus": true,
              "abnormalRatio": 0.95320195,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腎絲球過濾率",
              "examItem": "L300150001",
              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.46638596,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿酸",
              "examItem": "L3001400",
              "examMemo": "尿酸檢查可評估痛風及腎功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.3110547,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿液常規檢查",
              "examItem": "L4002000A",
              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
              "examType": "優先必要檢查項目",
              "examPrice": "130",
              "rateStatus": true,
              "abnormalRatio": 0.07999199,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "肌酸酐",
              "examItem": "L3001500",
              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.06713337,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "電解質",
              "examItem": "L3002100A",
              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
              "examType": "優先必要檢查項目",
              "examPrice": "270",
              "rateStatus": true,
              "abnormalRatio": 0.054231226,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿素氮",
              "examItem": "L3001300",
              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.020641107,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "睪固酮",
              "examItem": "LI001400",
              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "440",
              "rateStatus": true,
              "abnormalRatio": 0.08185654,
              "deptName": "男性醫學",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
              "examItem": "R1040501A",
              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "660",
              "rateStatus": true,
              "abnormalRatio": 0.83651227,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰薦椎正面及側面X光",
              "examItem": "R1041200A",
              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "440",
              "rateStatus": true,
              "abnormalRatio": 0.81395346,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理學檢查",
              "examItem": "PE00010023A",
              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.14126594,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "個人主訴",
              "examItem": "HI000001A",
              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胸部X光（正面及左側面）",
              "examItem": "R132001DA",
              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
              "examType": "優先必要檢查項目",
              "examPrice": "530",
              "rateStatus": true,
              "abnormalRatio": 0.33959147,
              "deptName": "肺部檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "聽力檢查",
              "examItem": "T700110011B",
              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
              "examType": "優先必要檢查項目",
              "examPrice": "190",
              "rateStatus": true,
              "abnormalRatio": 0.09931259,
              "deptName": "耳鼻喉科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "examType": "優先必要檢查項目",
              "examPrice": "40",
              "rateStatus": true,
              "abnormalRatio": 0.24298806,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼底斷層掃描",
              "examItem": "PE000001A",
              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
              "examType": "優先必要檢查項目",
              "examPrice": "1100",
              "rateStatus": true,
              "abnormalRatio": 0.22279978,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "石原色覺檢查表",
              "examItem": "PE00040014",
              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "40",
              "rateStatus": true,
              "abnormalRatio": 0.049161676,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0.042481624,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "維他命 D",
              "examItem": "VIT0002",
              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
              "examType": "優先必要檢查項目",
              "examPrice": "590",
              "rateStatus": true,
              "abnormalRatio": 0.88415545,
              "deptName": "營養素與礦物質",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上腹部超音波",
              "examItem": "R2022000A",
              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "1100",
              "rateStatus": true,
              "abnormalRatio": 0.90277964,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸丙酮酸轉氨基酶",
              "examItem": "L3000300",
              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.32915446,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "直接膽紅素",
              "examItem": "L3001710",
              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.14638714,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": 0.13758251,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸苯醋酸轉氨基酶",
              "examItem": "L3000200",
              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.11648777,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽紅素",
              "examItem": "L3001700",
              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.114548095,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸轉肽酶",
              "examItem": "L3000400",
              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.09633882,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白蛋白",
              "examItem": "L3018100",
              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.056706805,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鹼性磷酸酶",
              "examItem": "L3000100",
              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.023285212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "C型肝炎抗體測定",
              "examItem": "LG001400",
              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.009078212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總蛋白",
              "examItem": "L3001800",
              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "70",
              "rateStatus": true,
              "abnormalRatio": 0.008030916,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗體",
              "examItem": "L2002000",
              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "球蛋白",
              "examItem": "L301810003",
              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
              "examItem": "LB000401Q",
              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "4770",
              "rateStatus": true,
              "abnormalRatio": 0.9862259,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胃鏡",
              "examItem": "LB000201C",
              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "2570",
              "rateStatus": true,
              "abnormalRatio": 0.96851075,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "(新)雙項麻醉",
              "examItem": "PE001006",
              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "5800",
              "rateStatus": false,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鐵蛋白",
              "examItem": "L3004500",
              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.48436248,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血球計數",
              "examItem": "L5003200",
              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "250",
              "rateStatus": true,
              "abnormalRatio": 0.24270557,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白血球分類",
              "examItem": "L5000500",
              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
              "examType": "優先必要檢查項目",
              "examPrice": "80",
              "rateStatus": true,
              "abnormalRatio": 0.10483387,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "纖維蛋白原",
              "examItem": "L5002600",
              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "220",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          }
      ],
      "paymentAmount": 26410,
      "mutexItems": {},
      "addExamItemList": [],
      "removeItemQuestionMap": [],
      "originalExamItemList": [
          {
              "examName": "體脂肪率",
              "examItem": "PE00010019",
              "examMemo": "體脂肪率反映身體脂肪分佈，高於正常範圍可能增加心血管疾病、代謝症候群風險。檢查體脂肪率能幫助了解健康狀況，指導減肥及增肌計畫。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6588167,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體質量指數",
              "examItem": "PE00010006",
              "examMemo": "身體質量指數（BMI）是評估體重相對於身高的指標，幫助判斷是否過輕、正常、過重或肥胖，與多種健康風險如心血管疾病、糖尿病相關。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.6336039,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰圍",
              "examItem": "PE00010017",
              "examMemo": "腰圍是心血管疾病和代謝症候群的指標，高腰圍可能顯示腹部肥胖，增加健康風險。檢查腰圍有助於了解體重相關健康狀況。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.4081422,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血壓",
              "examItem": "PE00010009A",
              "examMemo": "血壓是心血管健康的重要指標，高血壓可能引發中風、心血管病等疾病。定期檢查血壓有助於及早發現問題，採取預防措施，維護健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.36203143,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脈搏",
              "examItem": "PE00010007A",
              "examMemo": "脈搏檢查能反映心臟健康與血液循環狀況，異常脈搏可能指出心血管疾病、高血壓或其他健康問題，及早發現有助於預防潛在風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.02100955,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上下肢肌力檢測",
              "examItem": "MMS001A",
              "examMemo": "肌少症易導致跌倒、活動力下降、肥胖、代謝慢性病增加和骨質疏鬆等風險，透過早期評估，取得個人化建議，及早預防肌少症。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.016194332,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身高",
              "examItem": "PE00010001",
              "examMemo": "身高是評估生長發育和健康狀況的重要指標，異常身高可能顯示內分泌失調、營養不良或遺傳問題，透過測量能早期發現潛在健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "200",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "體重",
              "examItem": "PE00010002",
              "examMemo": "體重是評估健康的重要指標，過重或過輕都可能影響身體機能，增加慢性疾病風險。定期檢查體重有助於及早發現健康問題並進行調整。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理想體重",
              "examItem": "PE00010003",
              "examMemo": "理想體重是衡量健康的指標，過重或過輕皆影響身體機能和疾病風險。維持理想體重有助於促進整體健康和減少慢性病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "身體組成分析",
              "examItem": "PE00010040",
              "examMemo": "身體組成分析可評估肌肉量、蛋白脂、脂肪和體內水分比例，繼而準確量度脂肪量、肌肉量和體脂百分比變化，幫助了解健康狀況及體重管理，促進整體健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "一般檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低密度脂蛋白-膽固醇",
              "examItem": "L3005200",
              "examMemo": "低密度脂蛋白膽固醇（LDL）是主要的心血管疾病風險指標，又稱壞膽固醇，過高會導致血管狹窄、硬化及阻塞，增加心血管疾病的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "375",
              "rateStatus": true,
              "abnormalRatio": 0.6037854,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽固醇",
              "examItem": "L3001900",
              "examMemo": "總膽固醇是衡量血液中膽固醇總量的指標，包括有益的高密度膽固醇（HDL）和有害的低密度膽固醇（LDL）。檢查總膽固醇有助於評估心血管疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.5826974,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高敏感性C反應蛋白",
              "examItem": "L3018400",
              "examMemo": "高敏感性C反應蛋白（hs-CRP）可偵測體內慢性發炎反應，評估心血管疾病風險",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.4319874,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "低/高密度脂蛋白比值",
              "examItem": "L300350002",
              "examMemo": "高密度脂蛋白（HDL）有助於清除膽固醇，降低心血管疾病風險。低/高密度脂蛋白比值的檢查能評估心血管健康風險，越高風險越大。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.3974091,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前血糖",
              "examItem": "L3000800",
              "examMemo": "飯前血糖檢查可反映人體對糖的控制能力，持續高血糖可能預示糖尿病或代謝異常，及早發現有助於飲食與生活方式調整，降低健康風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.38921002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "靜式心電圖",
              "examItem": "L1001100A",
              "examMemo": "靜式心電圖測量基本心臟運作是否正常，有助於檢查心律不整、心肌缺氧、心臟肥大等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "350",
              "rateStatus": true,
              "abnormalRatio": 0.3740002,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "糖化血色素",
              "examItem": "L3000700",
              "examMemo": "糖化血色素反映過去2-3個月的平均血糖水平，主要用於糖尿病診斷及控制，幫助評估糖尿病患者的治療效果及長期併發症風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.32150638,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "三酸甘油脂",
              "examItem": "L3002000",
              "examMemo": "三酸甘油脂是用來評估血脂異常與心血管疾病風險的重要指標之一，過高會增加動脈粥狀硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "180",
              "rateStatus": true,
              "abnormalRatio": 0.31154653,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總/高密度膽固醇比",
              "examItem": "L300350001",
              "examMemo": "總/高密度膽固醇比（TC/HDL）此比值可看出壞膽固醇佔比，越高表示心血管疾病風險增加",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.27469006,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "高密度脂蛋白-膽固醇",
              "examItem": "L3003500",
              "examMemo": "高密度脂蛋白（HDL）有助於清除血中的壞膽固醇，保護心血管健康。檢查HDL可評估心臟病風險，較高通常意味著風險較低。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.18991618,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "同半胱胺酸",
              "examItem": "L3018300",
              "examMemo": "同半胱胺酸為心血管疾病風險指標，濃度過高會提高血管硬化、心肌梗塞及中風的風險",
              "examType": "優先必要檢查項目",
              "examPrice": "800",
              "rateStatus": true,
              "abnormalRatio": 0.15489566,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "脫氫表雄酮硫酸鹽",
              "examItem": "LI005300",
              "examMemo": "脫氫表雄酮硫酸鹽（DHEAS）是一種性激素前驅物，檢查可幫助評估腎上腺功能及性激素失衡，對於多囊卵巢症候群和腎上腺疾病的診斷有重要意義。",
              "examType": "優先必要檢查項目",
              "examPrice": "500",
              "rateStatus": true,
              "abnormalRatio": 0.0952381,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "飯前胰島素(含阻抗)",
              "examItem": "LI001700A",
              "examMemo": "飯前胰島素檢查反映胰島素分泌與胰島素阻抗程度，有助於評估糖尿病風險與代謝健康。數值異常可指示潛在的代謝問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0.08467293,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "甲狀腺刺激素",
              "examItem": "LI000400",
              "examMemo": "甲狀腺刺激素（TSH）是由腦下垂體分泌的一種激素，負責調節甲狀腺的運作，TSH濃度的變化可以反映甲狀腺功能是否正常",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.034355164,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "游離甲狀腺素",
              "examItem": "LI003400",
              "examMemo": "游離甲狀腺素（Free T4）是一種由甲狀腺分泌的荷爾蒙，可直接反映甲狀腺功能是否正常，並影響全身新陳代謝。",
              "examType": "優先必要檢查項目",
              "examPrice": "500",
              "rateStatus": true,
              "abnormalRatio": 0.028777989,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "十年心血管疾病風險評估",
              "examItem": "R401470005",
              "examMemo": "十年心血管疾病風險評估幫助預測未來十年內發生心血管事件的機率，透過評估年齡、血壓、膽固醇等指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "全身體脂肪分析",
              "examItem": "R1140700A",
              "examMemo": "全身體脂肪分析可評估體脂分佈與肌肉量，提供健康指標，幫助預防肥胖相關疾病。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "1200",
              "rateStatus": true,
              "abnormalRatio": 0.95320195,
              "deptName": "心血管及代謝系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腎絲球過濾率",
              "examItem": "L300150001",
              "examMemo": "腎絲球過濾率（GFR）是評估腎功能的指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0.46638596,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿酸",
              "examItem": "L3001400",
              "examMemo": "尿酸檢查可評估痛風及腎功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.3110547,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿液常規檢查",
              "examItem": "L4002000A",
              "examMemo": "尿液常規檢查能評估泌尿系統(腎臟、膀胱、尿道)是否有損傷、發炎或功能異常。",
              "examType": "優先必要檢查項目",
              "examPrice": "170",
              "rateStatus": true,
              "abnormalRatio": 0.07999199,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "肌酸酐",
              "examItem": "L3001500",
              "examMemo": "肌酸酐是腎功能的指標。數值高可能暗示腎損傷或功能下降，檢查有助於早期發現腎臟問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.06713337,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "電解質",
              "examItem": "L3002100A",
              "examMemo": "電解質檢查可評估體內鈉、鉀等礦物質平衡，對維持神經和肌肉功能至關重要。",
              "examType": "優先必要檢查項目",
              "examPrice": "360",
              "rateStatus": true,
              "abnormalRatio": 0.054231226,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "尿素氮",
              "examItem": "L3001300",
              "examMemo": "尿素氮能反映腎臟排除體內廢物的功能，為判斷腎功能與代謝狀況的重要指標。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.020641107,
              "deptName": "腎臟泌尿系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "睪固酮",
              "examItem": "LI001400",
              "examMemo": "睪固酮是男性主要的性激素，影響性功能、肌肉質量及情緒。檢查睪固酮有助於評估生殖健康及識別荷爾蒙失調問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "600",
              "rateStatus": true,
              "abnormalRatio": 0.08185654,
              "deptName": "男性醫學",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "頸椎X光-正面及側片(伸展&屈曲)",
              "examItem": "R1040501A",
              "examMemo": "頸椎X光-正面及側片（伸展&屈曲）能評估頸椎骨骼排列及活動是否正常，幫助診斷頸部疼痛、受傷或神經壓迫等問題，有助於制定治療方案。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "900",
              "rateStatus": true,
              "abnormalRatio": 0.83651227,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "腰薦椎正面及側面X光",
              "examItem": "R1041200A",
              "examMemo": "腰薦椎正面及側面X光可評估腰椎、薦椎的結構和退化變化，協助診斷腰痛原因，檢查是否有椎間盤突出或其他脊椎問題，促進早期治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "600",
              "rateStatus": true,
              "abnormalRatio": 0.81395346,
              "deptName": "脊椎骨骼系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "理學檢查",
              "examItem": "PE00010023A",
              "examMemo": "理學檢查是醫生透過視診、觸診、叩診及聽診等方式評估病人健康狀況。能早期發現潛在疾病，提供診斷依據，並決定後續檢查或治療方向。",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.14126594,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "個人主訴",
              "examItem": "HI000001A",
              "examMemo": "個人主訴是病人就醫時的主要症狀，能幫助醫生了解疾病根本，制定針對性檢查和治療方案，提升診療效果。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "理學檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胸部X光（正面及左側面）",
              "examItem": "R132001DA",
              "examMemo": "胸部X光可檢查肺部、心臟及胸腔結構，幫助診斷肺炎、腫瘤或心臟擴大等問題，是評估呼吸與心臟健康的重要工具。",
              "examType": "優先必要檢查項目",
              "examPrice": "720",
              "rateStatus": true,
              "abnormalRatio": 0.33959147,
              "deptName": "肺部檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "聽力檢查",
              "examItem": "T700110011B",
              "examMemo": "簡易聽力檢查可早期發現聽力障礙。",
              "examType": "優先必要檢查項目",
              "examPrice": "250",
              "rateStatus": true,
              "abnormalRatio": 0.09931259,
              "deptName": "耳鼻喉科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "視力",
              "examItem": "PE00040001B",
              "examMemo": "視力檢查能評估眼睛健康，及早發現視力問題或潛在疾病，防止視力進一步惡化，確保日常生活品質。",
              "examType": "優先必要檢查項目",
              "examPrice": "50",
              "rateStatus": true,
              "abnormalRatio": 0.24298806,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼底斷層掃描",
              "examItem": "PE000001A",
              "examMemo": "眼底斷層掃描為廣角診斷影像系統，可檢視眼底組織病變，辨識視網膜、視神經及其他眼疾。",
              "examType": "優先必要檢查項目",
              "examPrice": "1500",
              "rateStatus": true,
              "abnormalRatio": 0.22279978,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "石原色覺檢查表",
              "examItem": "PE00040014",
              "examMemo": "石原色覺檢查表用於檢查色盲及色覺異常，透過特定圖案檢測視覺識別能力，幫助了解眼睛健康與視覺功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "50",
              "rateStatus": true,
              "abnormalRatio": 0.049161676,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "眼壓",
              "examItem": "PE00040004B",
              "examMemo": "眼壓檢查是評估青光眼及視神經健康的重要指標，過高眼壓可能損害視力。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.042481624,
              "deptName": "眼科檢查",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "維他命 D",
              "examItem": "VIT0002",
              "examMemo": "維他命 D是調節鈣質的重要營養素，對骨骼和免疫系統健康關鍵。",
              "examType": "優先必要檢查項目",
              "examPrice": "800",
              "rateStatus": true,
              "abnormalRatio": 0.88415545,
              "deptName": "營養素與礦物質",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "上腹部超音波",
              "examItem": "R2022000A",
              "examMemo": "上腹部超音波可無痛檢查肝臟、膽囊、胰臟、脾臟與腎臟，有助早期發現腫瘤、結石或發炎等問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "1500",
              "rateStatus": true,
              "abnormalRatio": 0.90277964,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸丙酮酸轉氨基酶",
              "examItem": "L3000300",
              "examMemo": "麩胺酸丙酮酸轉氨基酶是肝功能的指標，高可能表示肝臟受損或疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.32915446,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "直接膽紅素",
              "examItem": "L3001710",
              "examMemo": "直接膽紅素為肝臟代謝產物，升高可能與肝功能障礙或膽道阻塞有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.14638714,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗原",
              "examItem": "L2001900",
              "examMemo": "B型肝炎表面抗原是檢查B型肝炎病毒感染的重要指標，陽性結果表示可能感染，需進一步評估肝臟健康及傳染風險，有助於早期治療和防控。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": 0.13758251,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸苯醋酸轉氨基酶",
              "examItem": "L3000200",
              "examMemo": "麩胺酸苯醋酸轉氨基酶是肝臟和心肌的酵素，高可指示肝損傷、心臟疾病或其他健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.11648777,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總膽紅素",
              "examItem": "L3001700",
              "examMemo": "總膽紅素檢查可評估肝臟功能及膽道健康，過高可能表示肝臟疾病、膽結石或溶血性貧血，及早發現有助於預防併發症。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.114548095,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "麩胺酸轉肽酶",
              "examItem": "L3000400",
              "examMemo": "麩胺酸轉肽酶是肝功能的指標，主要用於檢測肝臟相關疾病，異常可能表示肝臟受損或酒精影響，及早檢查有助於疾病預防。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.09633882,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白蛋白",
              "examItem": "L3018100",
              "examMemo": "白蛋白是血清中重要的蛋白質，反映肝臟功能及營養狀態。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.056706805,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鹼性磷酸酶",
              "examItem": "L3000100",
              "examMemo": "鹼性磷酸酶(ALP)主要反映肝臟、膽道及骨骼健康。有助於診斷肝病、膽道阻塞或骨骼疾病，及早發現健康問題。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.023285212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "C型肝炎抗體測定",
              "examItem": "LG001400",
              "examMemo": "C型肝炎抗體測定可檢測是否曾感染C型肝炎病毒，高抗體表示過去感染或持續感染，及早發現可防止肝臟疾病進一步惡化。",
              "examType": "優先必要檢查項目",
              "examPrice": "450",
              "rateStatus": true,
              "abnormalRatio": 0.009078212,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "總蛋白",
              "examItem": "L3001800",
              "examMemo": "總蛋白檢查評估血液中蛋白質總量，反映身體營養狀況及肝臟、腸胃、腎臟功能。",
              "examType": "優先必要檢查項目",
              "examPrice": "90",
              "rateStatus": true,
              "abnormalRatio": 0.008030916,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "B型肝炎表面抗體",
              "examItem": "L2002000",
              "examMemo": "B型肝炎表面抗體檢查可確定是否曾感染或接種疫苗，若結果為陽性，表示有免疫保護，能有效預防B型肝炎病毒感染。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "球蛋白",
              "examItem": "L301810003",
              "examMemo": "球蛋白是血液中重要的蛋白質，參與免疫反應和運輸。檢查球蛋白水平可評估肝臟健康、免疫功能及感染狀態，幫助診斷相關疾病。",
              "examType": "優先必要檢查項目",
              "examPrice": "0",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "AI瘜肉偵測暨NBI大腸鏡-含代餐包",
              "examItem": "LB000401Q",
              "examMemo": "AI瘜肉偵測暨NBI大腸鏡透過AI與影像強化技術提升大腸瘜肉與早期病灶偵測率，有助預防大腸癌；代餐包提供檢查前所需營養攝取。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "6500",
              "rateStatus": true,
              "abnormalRatio": 0.9862259,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "胃鏡",
              "examItem": "LB000201C",
              "examMemo": "胃鏡檢查能直接觀察食道、胃及十二指腸前段，早期發現潰瘍、腫瘤等問題，對消化系統健康至關重要，有助於及時治療。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "3500",
              "rateStatus": true,
              "abnormalRatio": 0.96851075,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "(新)雙項麻醉",
              "examItem": "PE001006",
              "examMemo": "(新)雙項麻醉檢查用靜脈注射給予短效之鎮靜及麻醉止痛藥物進行全身麻醉，使受檢者在淺層麻醉狀態下進行檢查。",
              "examType": "潛在疾病風險檢查建議",
              "examPrice": "5800",
              "rateStatus": false,
              "abnormalRatio": 0,
              "deptName": "消化系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "鐵蛋白",
              "examItem": "L3004500",
              "examMemo": "鐵蛋白是體內鐵儲存的指標，低可能表示缺鐵性貧血，而高則可能與感染或慢性疾病有關。",
              "examType": "優先必要檢查項目",
              "examPrice": "400",
              "rateStatus": true,
              "abnormalRatio": 0.48436248,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "血球計數",
              "examItem": "L5003200",
              "examMemo": "血球計數可評估紅血球、白血球和血小板的數量，幫助診斷貧血、感染和血液疾病，瞭解整體健康狀況及潛在疾病風險。",
              "examType": "優先必要檢查項目",
              "examPrice": "330",
              "rateStatus": true,
              "abnormalRatio": 0.24270557,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "白血球分類",
              "examItem": "L5000500",
              "examMemo": "白血球分類檢查能評估免疫系統狀況，辨別感染、過敏或其他疾病。不同類型的白血球變化，能提供醫師診斷和治療的依據。",
              "examType": "優先必要檢查項目",
              "examPrice": "100",
              "rateStatus": true,
              "abnormalRatio": 0.10483387,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          },
          {
              "examName": "纖維蛋白原",
              "examItem": "L5002600",
              "examMemo": "纖維蛋白原是血液中的一種蛋白質，其升高可能表示有炎症或血栓風險。檢查纖維蛋白原能幫助評估血液凝固狀況及心血管健康。",
              "examType": "優先必要檢查項目",
              "examPrice": "300",
              "rateStatus": true,
              "abnormalRatio": null,
              "deptName": "血液系統",
              "selectFlag": 1,
              "disable": false
          }
      ],
      "lastSessionId": "210f3563-88bf-4ce4-9b59-fbeb9c692edd"
    }

  }
    

    // 注入無效 token
    this.injectInvalidToken();

    Object.entries(dirtyData).forEach(([key, value]) => {
      this.sharedStorageService.set(key as any, value);
    });

    this.toastr.success('髒資料已注入');

    console.log('注入髒資料完成：', dirtyData);
  }

  // 注入無效 token (測試用)
  injectInvalidToken() {
    const invalidToken = 'eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE3Njc2Njk2MzMsImV4cCI6MTc2Nzc1NjAzMywic3ViIjoiMWJhZDY0ZGEtMGVjZC00ZTRmLThlMmUtZmE4MTZlNGY3M2RhIiwic2lkIjoiZTFhNzZjYjAtMDJlMi00NjU2LWI3ZDItYWJjMTExODBjNzI5IiwidmVyIjoxLCJraW5kIjoiVVNFUiIsImlkbGUiOjE3Njc2NzE0MzMzODF9.LJnZg0yVWZo_fSMjmFAwRgzQ-QdNG5zKU11wMRF4Up4';
    this.authService.setToken(invalidToken);
    this.toastr.warning('無效 token 已注入');
    console.log('注入無效 token：', invalidToken);
  }
}
